import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Injector,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { NgxTippyProps } from "ngx-tippy-wrapper";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { ddlPublicPrivateList } from "src/app/core/models/predefineArrayListModel";
import { GLOBAL } from "src/app/core/services/config.service";
import { EventDataService } from "src/app/core/services/event-data.service";
import { ApiService } from "src/app/core/services/shared/api.service";
import { PredefineArrayListService } from "src/app/core/services/shared/predefine-array-list.service";
import {
  IntrestPageAnswer,
  stateAnswerModel,
} from "./../../core/models/answerMapModel";

import { EncryptDecreptService } from "src/app/core/services/shared/encrypt-decrept.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";

import { yearWiseROiCollegeData } from "src/app/core/models/interest-top5";

import { ActivatedRoute, Router } from "@angular/router";
import { TUI_NUMBER_FORMAT, TuiDialogService } from "@taiga-ui/core";
import { Subject } from "rxjs";
import { CheckLoginSessionService } from "src/app/core/services/shared/check-login-session.service";
import {
  Answer,
  ConfigMapService,
  FormResponse,
  InputType,
  Searchconfig,
  StepperInfo,
} from "virtue-form";
import { VfrUploadComponent } from "../shared/dialog/vfr-upload/vfr-upload.component";
import { CommonHandlerService } from "src/app/core/services/shared/common-handler.service";
import { element } from "protractor";
import { CollegeprofileComponent } from "../shared/dialog/collegeprofile/collegeprofile.component";
import { threadId } from "worker_threads";

@Component({
  selector: "app-interest-top5-college-selection",
  templateUrl: "./interest-top5-college-selection.component.html",
  styleUrls: ["./interest-top5-college-selection.component.scss"],
  providers: [
    {
      provide: TUI_NUMBER_FORMAT,
      useValue: { decimalSeparator: ".", thousandSeparator: "," },
    },
  ],
})
export class InterestTop5CollegeSelectionComponent implements OnInit {
  @Output() updateSectionTitleEvent = new EventEmitter<number>();
  filterCollegeItem: any = [];
  colors = ["90AACB", "FFB085", "F9D5A7"];
  dragAreaClass: string | undefined;

  onFileChange(event: any) {
    let files: FileList = event.target.files;
    this.saveFiles(files);
  }
  searchBoxvalue: Array<any> = [];
  affinityQuestionAnswer: Map<string, any> = new Map();
  ipedsId!: string;
  // @HostListener("click") dosomething() {
  //   this.globalvar.responsiveContentShowAndHide.next(false);
  // }
  yearWiseCollegeROIData: yearWiseROiCollegeData = {};
  basepath: string = "";
  timeout: any;
  efcFieldValue = [];
  stateGrantFieldValue = [];

  year: number;
  tippyPropsLeft = {
    placement: "top-start",
    arrow: false,
    theme: "light",
  };
  tippyProps = {
    placement: "top",
    arrow: true,
    theme: "light",
  };
  // private instancesChanges$: Subscription;

  public baseProps: NgxTippyProps = {
    arrow: true,
    theme: "light",
  };

  templateRef: NgxTippyProps = {
    ...this.baseProps,
    allowHTML: true,
    appendTo: "parent",
    interactive: true,
    interactiveBorder: 50,
  };

  // passInnerHTML: NgxTippyProps = this.templateRef;
  collegeSearchList: any;
  StateInOutMap: Map<string, stateAnswerModel> = new Map();
  @Output() inputwidgetoutput = new EventEmitter<Answer>();
  @Output() removewidgetInput = new EventEmitter<number>();
  @Input() answerMap!: Map<Number, Answer>;
  interestPageAnswerMap: Map<string, IntrestPageAnswer> = new Map();
  CollegeSelctionList: Map<string, IntrestPageAnswer> = new Map();
  ddlPublicPrivateList: Array<ddlPublicPrivateList>;
  debouncingData = new Subject<string>();
  // ddlPublicPrivateList = [
  //   {
  //     id: "PUBLIC",
  //     label: "Public",
  //     value: "PUBLIC",
  //   },
  //   {
  //     id: "PRIVATE_FOR_PROFIT",
  //     label: "Private, for-profit",
  //     value: "PRIVATE_FOR_PROFIT",
  //   },
  //   {
  //     id: "PRIVATE_NON_PROFIT",
  //     label: "Private, non-profit",
  //     value: "PRIVATE_NON_PROFIT",
  //   },
  // ];

  isSelectedUniversityItems: any = [false];
  modalRef: BsModalRef; // new variable
  modalParentRef: BsModalRef; // new variable
  mergerdUniversityList: any[] = []; // new variable
  selectedUniversityIndex: number;
  fileUploadArray = [];
  maxUniversityListArr: any = [];

  filesArray = [];
  acceptedFile = {};
  yearsArr = [];
  today: string;
  acceptFileType = "application/pdf,image/*";
  loadingImage = false;
  uploadFileType = {};
  fileInput: string;
  uploadmoreFlag: string = "No";
  errorMessage: any = "";
  fileIds = [];
  index;
  deleteBy: string;
  documentTypeId: string;
  IsLoadData: boolean = false;

  // config = {
  //   displayKey: "label", //if objects array passed which key to be displayed defaults to description
  //   search: true, //true/false for the search functionlity defaults to false,
  //   height: "auto", //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
  //   placeholder: "Select", // text to be displayed when no item is selected defaults to Select,
  //   customComparator: () => {}, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
  //   limitTo: 0, // number thats limits the no of options displayed in the UI (if zero, options will not be limited)
  //   moreText: "more", // text to be displayed whenmore than one items are selected like Option 1 + 5 more
  //   noResultsFound: "No results found!", // text to be displayed when no items are found while searching
  //   searchPlaceholder: "Search", // label thats displayed in search input,
  //   searchOnKey: "label", // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  // };

  // showuploadButton = [];
  selectedStates = [];
  // startInterval: any;
  // stopInterval: any;

  statelist: any = [
    { id: "ar", label: "Arizona" },
    { id: "mn", label: "Minnesota" },
  ]; // not in use now
  selectedUniversityList: any[] = [];
  yearWiseAffinityQuestion: any[] = [];
  selectedUniversityCSSProfile: any[] = [];
  selectedUniversityStateGrant: any[] = [];

  ocrResponseListTotal: any = [];
  analysisData = false;
  residenceOptions = [];

  housingNotAvailableOption = [
    {
      label: "Off Campus",
      value: "OFF_CAMPUS_NOT_FAMILY",
      src: "https://cdn.virtueanalytics.com/cache/off-camps.png",
    },
    {
      label: "Off Campus with Family",
      value: "OFF_CAMPUS_FAMILY",
      src: "https://cdn.virtueanalytics.com/cache/on-camp-family-top5.png",
    },
  ];

  housingAvailableOption = [
    {
      label: "On Campus",
      value: "ON_CAMPUS",
      src: "https://cdn.virtueanalytics.com/cache/on-camp-top5.png",
    },
    {
      label: "Off Campus",
      value: "OFF_CAMPUS_NOT_FAMILY",
      src: "https://cdn.virtueanalytics.com/cache/off-camps.png",
    },
    {
      label: "Off Campus with Family",
      value: "OFF_CAMPUS_FAMILY",
      src: "https://cdn.virtueanalytics.com/cache/on-camp-family-top5.png",
    },
  ];

  isSaveData: boolean = false;
  showSuggestions: boolean = false;
  collegeRepeat: Array<any> = [];
  domesileStatus: string[] = [];
  residencyStatus: string[] = [];
  studentInputdata: any;
  pageStepsNo: number;
  stateCalculatorList: any = [];
  totalAmount = {
    totalCoa: 0,
    totalGrantsSCholarship: 0,
    totalLoan: 0,
    totalAdditionalost: 0,
    outOfPocket: 0,
    coaCorrect: true,
    grantCorrect: true,
    coaValidated: false,
    grantValidated: false,
  };

  @Output() optionData = new EventEmitter<any>();
  constructor(
    public globalvar: GlobalVarService,
    private elem: ElementRef,
    private spinnerService: NgxSpinnerService,
    private predefineArray: PredefineArrayListService,
    private EncryptDecrpt: EncryptDecreptService,
    public apiService: ApiService,
    private eventDataService: EventDataService,
    private modalService: BsModalService,
    private checkUserLogin: CheckLoginSessionService,
    private cdref: ChangeDetectorRef,
    private configmap: ConfigMapService,
    private commonHandler: CommonHandlerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    this.ddlPublicPrivateList = this.predefineArray.ddlPublicPrivateList;

    //Start : search College Name by Autocomplete Search Box call
    // .toLowerCase().replaceAll(regrex, "")
    this.debouncingData
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((search) => {
        const regrex = /[^a-z]+/g;
        this.collegeRepeat = this.globalvar.selectedUniversityList;
        let data = { name: search };
        console.log(data, "data");

        this.apiService.searchCollegeName(data).then((res) => {
          let searchObj = res;
          let searchclgList = [];
          Object.keys(searchObj).forEach((key) => {
            if (searchObj[key].matchedAgainst != null) {
              let obj = {
                key: searchObj[key].matchedAgainst.ipedsId,
                value: searchObj[key].matchedAgainst.name,
                stateCode: searchObj[key].matchedAgainst.stateCode,
                // searchKey: searchObj[key].matchedAgainst.name.replaceAll(
                //   /[^a-z+]/g,
                //   ""
                // ),
              };
              if (this.collegeRepeat.length == 0) {
                searchclgList.push(obj);
              } else {
                if (
                  this.collegeRepeat.find(
                    (element: any) => element?.ipedsId == obj.key
                  )
                ) {
                } else {
                  searchclgList.push(obj);
                }
              }
            }
          });
          this.collegeSearchList = searchclgList;
          this.showSuggestions = true;
        });
      });
    // End
  }
  @HostListener("dragover", ["$event"])
  onDragOver(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }

  @HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragend", ["$event"]) onDragEnd(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("drop", ["$event"]) onDrop(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      let files: FileList = event.dataTransfer.files;
      this.saveFiles(files);
    }
  }

  saveFiles(files: FileList) {
    if (files.length > 1) {
      // this.error = "Only one file at time allow";
    } else {
      // this.error = "";
    }
  }
  getControlType(type: string) {
    if (type == "PUBLIC") {
      return "Public";
    }
    if (type == "PRIVATE_FOR_PROFIT") {
      return "Private";
      // return "Private, for-profit";
    }
    if (type == "PRIVATE_NON_PROFIT") {
      return "Private";
      // return "Private, non-profit";
    }
  }
  ngOnChanges() {}

  ngOnInit() {
    console.log(this.searchBoxvalue);

    let stateCalulatorAlreadyExists = this.globalvar.getAllStateList.get(
      "stateListStateCalculator"
    );
    if (stateCalulatorAlreadyExists.length > 0) {
      this.stateCalculatorList = stateCalulatorAlreadyExists;
    }
    this.globalvar.isLoadSaveData.subscribe((isSave: boolean) => {
      if (isSave == true) {
        this.isSaveData = true;
      }
    });

    //  Check Reciprocity State Items subscribe

    this.globalvar.checkedReciprocityMap.subscribe((state) => {
      if (state) {
        if (this.globalvar.isSubscribe == true) {
          this.selectCollegeReciprocityStateWise(state);
        }
      }
    });

    // Unchecked Reciprocity State Items subscribe
    this.globalvar.UnCheckedReciprocityMap.subscribe((state) => {
      if (state) {
        if (this.globalvar.isSubscribe == true) {
          this.selectCollegeReciprocityStateWise(state);
        }
      }
    });
    let year = new Date().getFullYear();
    this.year = year;
    while (year >= 2002) {
      this.yearsArr.push(year);
      year--;
    }
    if (this.globalvar.answerMap) {
      this.studentInputdata = this.globalvar.answerMap.get(6);
      this.answerMap = this.globalvar.answerMap;
    }

    if (this.globalvar.affinityQuestionAnswer) {
      this.affinityQuestionAnswer = new Map(
        this.globalvar.affinityQuestionAnswer
      );
    }

    if (this.globalvar.StateInOutMap) {
      this.StateInOutMap = new Map(this.globalvar.stateAnswerModel);
    }

    // if (this.globalvar.CollegeSelctionList) {
    //   this.CollegeSelctionList = new Map(this.globalvar.CollegeSelctionList);

    //   this.setDefaultSelectedColleges();
    // }

    setTimeout(() => {
      if (this.globalvar.CollegeSelctionList) {
        this.CollegeSelctionList = new Map(this.globalvar.CollegeSelctionList);
        this.setDefaultSelectedColleges();
      }
      this.cdref.detectChanges();
    }, 500);
    // }

    this.basepath = this.globalvar.basepath;
    this.globalvar.pageChange.subscribe((value: StepperInfo) => {
      if (value) {
        this.pageStepsNo = value.page;
      }
    });

    GLOBAL.FILE_UPLOAD_PAGE = this;
    this.today =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() < 10
        ? "0" + new Date().getMonth()
        : new Date().getMonth()) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate());

    this.fileUploadArray.push({
      dateOfAward: this.getToday(new Date()),
      award: "Annual",
      universityName: "",
      documentFileFormat: "PDF",
      fileIds: [],
      files: [],
    });
  }

  // onContainerClick(event: MouseEvent) {
  //   // Check if the click event originated from inside the input
  //   const inputElement = document.querySelector('.autocomplete input');
  //   if (inputElement && inputElement.contains(event.target as Node)) {
  //     this.showSuggestions = true; // Show the suggestions
  //   } else {
  //     this.showSuggestions = false; // Hide the suggestions
  //   }
  // }

  setListFromAnswerMap() {
    let sList = this.CollegeSelctionList.get("selectedUniversityList");
    if (sList) {
      this.selectedUniversityList = sList.list;
    }
    let maxUList = this.CollegeSelctionList.get("maxUniversityListArr");
    if (maxUList) {
      this.maxUniversityListArr = maxUList.list;
    }
    let isSelctedUItems = this.CollegeSelctionList.get(
      "isSelectedUniversityItems"
    );

    if (isSelctedUItems) {
      this.isSelectedUniversityItems = isSelctedUItems.list;
    }

    let yearWiseAQList = this.CollegeSelctionList.get(
      "yearWiseAffinityQuestion"
    );
    if (yearWiseAQList) {
      this.yearWiseAffinityQuestion = yearWiseAQList.list;
    }

    let selectedUCSSProfileList = this.CollegeSelctionList.get(
      "selectedUniversityCSSProfile"
    );
    if (selectedUCSSProfileList) {
      this.selectedUniversityCSSProfile = selectedUCSSProfileList.list;
    }
    let efcFieldValue = this.CollegeSelctionList.get("efcFieldValue");
    if (efcFieldValue) {
      this.efcFieldValue = efcFieldValue.list;
    }

    let ocrResponseListTotal = this.CollegeSelctionList.get(
      "ocrResponseListTotal"
    );
    if (ocrResponseListTotal) {
      this.ocrResponseListTotal = ocrResponseListTotal.list;
    }
    let residencyStatus = this.CollegeSelctionList.get("residencyStatus");
    if (residencyStatus) {
      this.residencyStatus = residencyStatus.list;
    }
    let domesileStatus = this.CollegeSelctionList.get("domesileStatus");
    if (domesileStatus) {
      this.domesileStatus = domesileStatus.list;
    }
    let selectedStates = this.CollegeSelctionList.get("selectedStates");
    if (selectedStates) {
      this.selectedStates = selectedStates.list;
    }
  }

  onSelected(val: any) {
    this.searchBoxvalue = [];
    let obj = {
      ipedsId: val.key,
      list: this.collegeSearchList,
      defaultLabel: val.value,
    };
    this.globalvar.deleteBy = "";
    this.ipedsId = "";
    this.deleteBy = "";
    let index = this.maxUniversityListArr.length;
    this.collegeSearchList = [];
    this.selectUniversity("autoSearchCollege", index, obj);
  }

  // getAutoSearchData(search: string) {
  //   if (search == "") {
  //   }
  //   this.collegeRepeat = this.globalvar.selectedUniversityList;
  //   let data = {
  //     name: search,
  //   };
  //   this.apiService.searchCollegeName(data).then((res) => {
  //     let searchObj = res;
  //     let searchclgList = [];
  //     Object.keys(searchObj).forEach((key) => {
  //       if (searchObj[key].matchedAgainst != null) {
  //         let obj = {
  //           key: searchObj[key].matchedAgainst.ipedsId,
  //           value: searchObj[key].matchedAgainst.name,
  //           stateCode: searchObj[key].matchedAgainst.stateCode,
  //         };
  //         if (this.collegeRepeat.length == 0) {
  //           searchclgList.push(obj);
  //         } else {
  //           if (
  //             this.collegeRepeat.find(
  //               (element: any) => element?.ipedsId == obj.key
  //             )
  //           ) {
  //           } else {
  //             searchclgList.push(obj);
  //           }
  //         }
  //       }
  //     });
  //     this.collegeSearchList = searchclgList;
  //   });
  // }
  getAutoSearchData(ev: any) {
    if (ev.keyCode !== 8) {
      this.debouncingData.next(ev.target.value);
    }
    // console.log(ev);

    //   if(search==""){

    // }

    // this.collegeRepeat=this.globalvar.selectedUniversityList;
    // let data={name:search};
    //   this.apiService.searchCollegeName(data).then((res)=>
    //   {let searchObj=res;let searchclgList=[];
    //     Object.keys(searchObj).forEach((key)=>
    //     {if(searchObj[key].matchedAgainst!=null)
    //       {
    //         let obj={key:searchObj[key].matchedAgainst.ipedsId,value:searchObj[key].matchedAgainst.name,stateCode:searchObj[key].matchedAgainst.stateCode,};
    //         if(this.collegeRepeat.length==0){searchclgList.push(obj);}else{if(this.collegeRepeat.find((element:any)=>element?.ipedsId==obj.key)){}else{searchclgList.push(obj);}}}});this.collegeSearchList=searchclgList;});
  }

  getToday(date) {
    var local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }

  setStateInoutMap(
    i: number,
    stateCode: string,
    ipedsId: string,
    change: string
  ) {
    let stateInOut = "";
    let getStateAnswerMap = this.StateInOutMap.get("state" + stateCode);
    if (!getStateAnswerMap) {
      if (this.studentInputdata.value != undefined) {
        if (this.studentInputdata.value == stateCode) {
          stateInOut = "IN_STATE";
        } else {
          stateInOut = "OUT_STATE";
        }

        let stateAnswer = {
          stateCode: stateCode,
          stateInOut: stateInOut,
          defaultLabel: change,
        };
        this.StateInOutMap.set("state" + stateCode, stateAnswer);
        this.StateInOutMap = new Map(this.StateInOutMap);
        this.globalvar.stateAnswerModel = this.StateInOutMap;
      }
    } else {
      if ("manualchanged" != getStateAnswerMap.defaultLabel) {
        if (this.studentInputdata.value != undefined) {
          // if("manualchanged"==getStateAnswerMap.defaultLabel)
          // {

          if (this.studentInputdata.value == stateCode) {
            stateInOut = "IN_STATE";
          } else {
            stateInOut = "OUT_STATE";
          }

          let stateAnswer = {
            stateCode: stateCode,
            stateInOut: stateInOut,
            defaultLabel: getStateAnswerMap.defaultLabel,
          };
          this.StateInOutMap.set("state" + stateCode, stateAnswer);
          this.StateInOutMap = new Map(this.StateInOutMap);
          this.globalvar.stateAnswerModel = this.StateInOutMap;
        }
      }
    }
  }

  setInterestPageAnswer(
    index: string,
    selectedValue: string,
    list: any,
    selectedLabel: any
  ) {
    let ans = {
      defaultLabel: selectedLabel,
      defaultValue: selectedValue,
      list: list,
    };
    this.CollegeSelctionList.set(index, ans);
    this.CollegeSelctionList = new Map(this.CollegeSelctionList);
    this.globalvar.CollegeSelctionList = this.CollegeSelctionList;
  }

  setCollegeList(
    index: string,
    selectedValue: string,
    list: any,
    selectedLabel: any
  ) {
    let ans = {
      defaultLabel: selectedLabel,
      defaultValue: selectedValue,
      list: list,
    };
    this.CollegeSelctionList.set(index, ans);
    this.CollegeSelctionList = new Map(this.CollegeSelctionList);
    this.globalvar.CollegeSelctionList = this.CollegeSelctionList;
  }

  resetstateMap(i: string) {
    let getStateAnswerMap = this.CollegeSelctionList.get(i);
    if (getStateAnswerMap) {
      this.setInterestPageAnswer(i, "", getStateAnswerMap.list, "Select State");
    }
  }

  deleteArrayListRows(index: number) {
    this.globalvar.saveChangedDeduct = true;
    this.maxUniversityListArr.splice(index, 1);
    this.isSelectedUniversityItems.splice(index, 1);
    this.selectedUniversityList.splice(index, 1);
    this.globalvar.selectedUniversityList = this.selectedUniversityList;

    if (this.maxUniversityListArr.length == 0) {
      this.isSelectedUniversityItems = [false];
    }

    let no = this.selectedUniversityList.filter(
      (element: any) => element.ipedsId != undefined
    );
    if (this.yearWiseAffinityQuestion[index]) {
      this.yearWiseAffinityQuestion.splice(index, 1);
    }
    if (this.selectedUniversityCSSProfile[index]) {
      this.selectedUniversityCSSProfile.splice(index, 1);
      this.efcFieldValue.splice(index, 1);
    }

    if (this.selectedUniversityStateGrant[index]) {
      this.selectedUniversityStateGrant.splice(index, 1);
      this.stateGrantFieldValue.splice(index, 1);
    }
    this.domesileStatus.splice(index, 1);
    this.selectedStates.splice(index, 1);
    this.ocrResponseListTotal.splice(index, 1);
    this.residencyStatus.splice(index, 1);
  }

  checkDisableNextBtn() {
    // let isSelectState = this.isSelectedStateItems.some((item) => item == false);
    // let isCssProfile = this.efcFieldValue.some(
    //   (item) => item == "" || item == undefined
    // );

    let isCssProfile = this.efcFieldValue.some(
      (item) => item != 0 && item == undefined
    );

    let isStateGrant = this.stateGrantFieldValue.some(
      (item) => item != 0 && item == undefined
    );
    let isSelectUniversity = this.isSelectedUniversityItems.some(
      (item) => item == false
    );
    if (
      isStateGrant == true ||
      isSelectUniversity == true ||
      isCssProfile == true ||
      this.IsLoadData == true
    ) {
      return true;
    } else {
      return false;
    }
  }

  restModalFields() {
    this.efcFieldValue = [];
    this.stateGrantFieldValue = [];
  }

  reset() {
    this.maxUniversityListArr = [];
    this.isSelectedUniversityItems[0] = false;
    this.selectedStates = [];
    this.selectedUniversityList = [];
    this.ocrResponseListTotal = [];
    this.yearWiseAffinityQuestion = [];
    this.selectedUniversityCSSProfile = [];
    this.selectedUniversityStateGrant = [];
    this.searchBoxvalue = [];

    this.restModalFields();

    this.restAnswerMap();
  }

  restAnswerMap() {
    this.CollegeSelctionList.clear();
    this.globalvar.CollegeSelctionList.clear();
    this.globalvar.interestPageAnswerMap.clear();
    this.StateInOutMap.clear();
    this.globalvar.StateInOutMap.clear();
    this.globalvar.affinityQuestionAnswer.clear();
    this.globalvar.filterSelected.clear();
  }

  checkAffinityYearWiseAvailable(yearWiseAffinityQuestion: any) {
    let yearWiseAffinity: any = [];
    if (
      yearWiseAffinityQuestion &&
      yearWiseAffinityQuestion[this.year] != undefined
    ) {
      yearWiseAffinity = yearWiseAffinityQuestion[this.year];
    } else {
      if (
        yearWiseAffinityQuestion &&
        yearWiseAffinityQuestion[this.year - 1] != undefined
      ) {
        yearWiseAffinity = yearWiseAffinityQuestion[this.year - 1];
      }
    }

    return yearWiseAffinity;
  }

  getAffinityQuestionYear(yearWiseAffinityQuestion: any) {
    let year: number = 0;
    if (
      yearWiseAffinityQuestion &&
      yearWiseAffinityQuestion[this.year] != undefined
    ) {
      year = this.year;
    } else {
      if (
        yearWiseAffinityQuestion &&
        yearWiseAffinityQuestion[this.year - 1] != undefined
      ) {
        year = this.year - 1;
      }
    }

    return year;
  }

  getCollegeROIData(roiData: any) {
    const year = 2022;
    let yearWiseData: any = [];
    if (roiData && roiData[year] != undefined) {
      yearWiseData = roiData[year];
    } else {
      if (roiData && roiData[year - 1] != undefined) {
        yearWiseData = roiData[year - 1];
      }
    }

    return yearWiseData;
  }

  getyearWiseCollegeData(yearWiseCollegeData: any) {
    let year = 0;
    if (yearWiseCollegeData && yearWiseCollegeData[this.year] != undefined) {
      year = this.year;
    } else {
      if (
        yearWiseCollegeData &&
        yearWiseCollegeData[this.year - 1] != undefined
      ) {
        year = this.year - 1;
      }
    }

    return year;
  }
  customicon: boolean = false;
  setCollegeProfileData(res: any, index: number, type: string, value: any) {
    this.selectedUniversityList[index] = res;

    let obj = {
      collegeProfileIcon: "",
      imageAvailable: false,
      defaultLabelColor: "",
    };
    this.apiService.getCollegeProfileIcon(res.ipedsId, (resp) => {
      if (resp.status === 0 || resp.status === 200) {
        // obj.collegeProfileIcon = resp.url;
        // obj.imageAvailable = true;
        // this.selectedUniversityList[index] = obj;

        this.selectedUniversityList[index].collegeProfileIcon = resp.url;
        this.selectedUniversityList[index].imageAvailable = true;
        this.selectedUniversityList[index].defaultLabelColor = "";
      } else {
        this.selectedUniversityList[index].collegeProfileIcon = "";
        this.selectedUniversityList[index].imageAvailable = false;
        this.selectedUniversityList[index].defaultLabelColor =
          this.AddRandomColor();
        //this.selectedUniversityList[index] = obj;
      }
    });

    this.filterCollegeItem = [];
    if (type == "autoSearchCollege") {
      let obj = {
        ipedsId: res.ipedsId,
        collegeName: res?.name,
        stateCode: res?.stateCode,
        collegeType: res?.control,
        enrollmentType: res?.enrollmentType,
        hbcuCollege: res?.hbcuCollege,
      };
      this.filterCollegeItem.push(obj);
    }

    this.maxUniversityListArr[index] = res;
    this.setCollegeList(
      "maxUniversityListArr",
      "",
      this.maxUniversityListArr,
      ""
    );

    this.isSelectedUniversityItems[index] = true;
    this.selectedStates[index] = res.stateCode;
    this.globalvar.selectedUniversityList = this.selectedUniversityList;
    this.selectedUniversityList[index].enrollmentType = res.enrollmentType;

    this.setStateInoutMap(
      index,
      this.selectedUniversityList[index].stateCode.toLowerCase(),
      value.ipedsId,
      "change"
    );

    let yearWiseAffinityQuestion = this.checkAffinityYearWiseAvailable(
      this.selectedUniversityList[index].yearWiseAffinityQuestion
    );
    if (yearWiseAffinityQuestion.length > 0) {
      this.setAffinityQuestionDefaultAnswer(
        this.selectedUniversityList[index].ipedsId,
        yearWiseAffinityQuestion,
        index
      );
      this.yearWiseAffinityQuestion[index] = yearWiseAffinityQuestion;
    } else {
      this.yearWiseAffinityQuestion[index] = [];
    }

    this.checkedStudentResidenceSelectedState(
      "domicileToggle",
      index,
      value.ipedsId,
      this.selectedUniversityList[index].stateCode.toLowerCase()
    ); //set domicileToggle

    let housingNotAvailable: boolean = false;
    housingNotAvailable =
      this.selectedUniversityList[index]["housingNotAvailable"];

    if (housingNotAvailable != undefined) {
      const residencyDropdown = this.CollegeSelctionList.get(
        "r" + value.ipedsId
      );
      if (residencyDropdown) {
        this.residencyStatus[index] = residencyDropdown.defaultValue;
      } else {
        if (housingNotAvailable == true) {
          this.changeResidencyCampuse(
            "residencyDropdown",
            index,
            "OFF_CAMPUS_NOT_FAMILY",
            value.ipedsId,
            "change"
          );
        } else {
          this.changeResidencyCampuse(
            "residencyDropdown",
            index,
            "ON_CAMPUS",
            value.ipedsId,
            "change"
          );
        }
      }
    }

    this.changeInOutState(
      "domicileToggle",
      index,
      this.domesileStatus[index],
      value.ipedsId,
      this.selectedUniversityList[index].stateCode.toLowerCase(),
      "change"
    );

    if (this.selectedUniversityList[index].usingCSSProfile) {
      let efc = this.affinityQuestionAnswer.get("aq" + value.ipedsId + "-9999");
      let defefc = this.CollegeSelctionList.get("aq" + value.ipedsId + "-9999");
      if (
        efc &&
        defefc?.defaultLabel != "defaultEFC" &&
        defefc != undefined &&
        defefc?.defaultLabel != undefined
      ) {
        this.efcFieldValue[index] = efc["9999"]?.amount;
        this.selectedUniversityList[index].selectedcssProfile =
          efc["9999"]?.amount;

        if (this.globalvar.saveChangedDeduct == true) {
          this.getMeritScholarShipCombindData(
            index,
            value.ipedsId,
            this.domesileStatus[index] + "_" + this.residencyStatus[index]
          );
        }
      } else {
        let efc = this.answerMap.get(40);
        this.setCssProfileEFC("ChangeAnswer", index, 9999, efc.value);
      }

      const obj = {
        selectedCSSEFC: "no",
        eligibility:
          "This college uses CSS profile for SAI calculation, please enter your CSS SAI.",
        label:
          "This college uses CSS profile for SAI calculation, please enter your CSS SAI.",
        options: [],
        terms: "",
      };
      this.selectedUniversityCSSProfile[index] = [obj];
    } else {
      this.selectedUniversityCSSProfile[index] = [];
      // this.efcFieldValue[index] = null;
    }
    this.setArrayListInAnswerMap();
  }
  checkIconStatus(collegeIcon: string): string {
    return collegeIcon ===
      "https://cdn.virtueanalytics.com/cache/college-icon-top5.png"
      ? "custom-icon"
      : "";
  }
  selectUniversity(type: string, index: number, value: any) {
    this.spinnerService.show();
    // this.IsLoadData = true;
    this.apiService.getCollegeProfileById1(value.ipedsId, (res) => {
      this.searchBoxvalue = [];

      this.globalvar.saveChangedDeduct = true;
      this.setCollegeProfileData(res, index, type, value);
      this.getDataCampuseAndToggleValue(index, value.ipedsId, "");
      this.setArrayListInAnswerMap();
      // this.checkUploadLetter(value.ipedsId, index);
      // this.IsLoadData = false;
    });
  }

  checkUploadLetter(ipedsId: number, index: number) {
    let uploadLetterAnswer = this.CollegeSelctionList.get("ul" + ipedsId);
    if (uploadLetterAnswer != undefined) {
      if (
        uploadLetterAnswer.defaultValue == "" + ipedsId &&
        uploadLetterAnswer.list.length > 0
        // uploadLetterAnswer.defaultLabel == "Uploaded"
      ) {
        this.ocrResponseListTotal[index] = uploadLetterAnswer.list[0];
        return "assets/images/uploaded3.png";
      } else {
        this.ocrResponseListTotal[index] = undefined;
        return "https://cdn.virtueanalytics.com/cache/award-letter-icon-top5.png";
      }
    } else {
      this.ocrResponseListTotal[index] = undefined;
      return "https://cdn.virtueanalytics.com/cache/award-letter-icon-top5.png";
    }
  }

  setAffinityQuestionDefaultAnswer(
    ipedsId,
    AffinityQuestionDefaultAnswer: any,
    uIndex: number
  ) {
    for (let index = 0; index < AffinityQuestionDefaultAnswer.length; index++) {
      const affinityQuestion = AffinityQuestionDefaultAnswer[index];

      let IntrestPageAnswer = this.CollegeSelctionList.get(
        "aq" + ipedsId + "-" + index
      );

      if (IntrestPageAnswer != undefined) {
        if (IntrestPageAnswer.defaultValue) {
          this.changeAffinityQuestionOption(
            "SetAnswer",
            uIndex,
            index,
            IntrestPageAnswer.defaultValue
          );
        }
      } else {
        for (
          let aindex = 0;
          aindex < affinityQuestion.options.length;
          aindex++
        ) {
          const opt = affinityQuestion.options[aindex];
          if (aindex == 1) {
            this.changeAffinityQuestionOption(
              "ChangeAffinity",
              uIndex,
              index,
              opt
            );
          }
        }
      }
    }
  }

  restSearchCollegeItem() {
    this.filterCollegeItem = [];
  }

  disabledClass() {
    if (this.maxUniversityListArr.length == 25) {
      return "disabled-search";
    } else {
      return "";
    }
  }

  setCssProfileEFC(type: string, index: number, option: number, value: string) {
    let ipedsId = "";
    ipedsId = this.selectedUniversityList[index]?.ipedsId;
    if (type == "ChangeAnswer") {
      if (this.selectedUniversityList[index]?.usingCSSProfile) {
        this.efcFieldValue[index] = value;
        this.setInterestPageAnswer(
          "aq" + ipedsId + "-" + option,
          value,
          [],
          "defaultEFC"
        );
        let usingCSSProfile = {
          option: option,
          amount: value,
        };
        let curData = { [option]: usingCSSProfile };
        this.getAffinityQustionAnswerMap(ipedsId, option, curData);
      }
    }

    if (
      this.selectedUniversityList[index].usingCSSProfile &&
      type == "ChangeAnswer"
    ) {
      this.selectedUniversityList[index].selectedcssProfile = value;
      if (this.globalvar.saveChangedDeduct == true) {
        this.getMeritScholarShipCombindData(
          index,
          ipedsId,
          this.domesileStatus[index] + "_" + this.residencyStatus[index]
        );
      }
    }
  }

  changeAffinityQuestionOption(
    type: string,
    index: number,
    option: number,
    optionSelected: any
  ) {
    let affinityAnswer;
    let ipedsId = "";
    ipedsId = this.selectedUniversityList[index]?.ipedsId;
    if (type == "ChangeAffinity") {
      {
        this.globalvar.saveChangedDeduct = true;

        this.setInterestPageAnswer(
          "aq" + ipedsId + "-" + option,
          optionSelected.value,
          [],
          ""
        );
        affinityAnswer = {
          option: option,
          amount: optionSelected.amount,
        };

        optionSelected = optionSelected.value;
        let curData = this.affinityQuestionAnswer.get(
          "aq" + ipedsId + "-" + option
        );
        if (curData) {
          curData = { ...curData, ...{ [option]: affinityAnswer } };
        } else {
          curData = { [option]: affinityAnswer };
          this.getAffinityQustionAnswerMap(ipedsId, option, curData);
        }
      }
    }

    if (type == "SetAnswer") {
      optionSelected = optionSelected;
    }

    let year = this.getAffinityQuestionYear(
      this.selectedUniversityList[index].yearWiseAffinityQuestion
    );

    if (type != "ChangeAnswer" && year) {
      this.selectedUniversityList[index].yearWiseAffinityQuestion[year][
        "AffinityQuestionSelectedOption"
      ] = optionSelected;
      this.selectedUniversityList[index].yearWiseAffinityQuestion[year][option][
        "AffinityQuestionSelectedOption"
      ] = optionSelected;
      let totalamt = 0;
      if (
        this.selectedUniversityList[index].yearWiseAffinityQuestion[year].length
      )
        this.selectedUniversityList[index].yearWiseAffinityQuestion[
          year
        ].forEach((key) => {
          key.options.forEach((element) => {
            if (element.value === key["AffinityQuestionSelectedOption"]) {
              totalamt += element.amount;
            }
          });
        });
      this.selectedUniversityList[index].yearWiseAffinityQuestion[year][0][
        "AffinityQuestionSelectedAmount"
      ] = totalamt;
      this.selectedUniversityList[index].yearWiseAffinityQuestion[year][
        "AffinityQuestionSelectedAmount"
      ] = totalamt;

      this.createAffinityQuestions(index, year);
    }
  }

  changeCSSEFCProfileAmount(
    type: string,
    index: number,
    option: number,
    val: string
  ) {
    this.globalvar.saveChangedDeduct = true;
    let ipedsId = this.selectedUniversityList[index]?.ipedsId;
    var efcAmount = "";
    if (val == null) {
      efcAmount = undefined;
    } else {
      efcAmount = val;
    }
    if (
      type == "ChangeAnswer" &&
      this.selectedUniversityList[index]?.usingCSSProfile
    ) {
      this.efcFieldValue[index] = efcAmount;
      this.setInterestPageAnswer(
        "aq" + ipedsId + "-" + option,
        efcAmount,
        [],
        ""
      );
      let usingCSSProfile = {
        option: option,
        amount: efcAmount,
      };
      let curData = { [option]: usingCSSProfile };
      this.getAffinityQustionAnswerMap(ipedsId, option, curData);
      this.selectedUniversityList[index].selectedcssProfile = val;

      // this.spinnerService.show();
      this.getMeritScholarShipCombindData(
        index,
        ipedsId,
        this.domesileStatus[index] + "_" + this.residencyStatus[index]
      );
    }
  }

  // changeStateGrantAmount(
  //   stateCode: string,
  //   index1: string,
  //   ipedsId: string,
  //   value: string
  // ) {
  //   let stateGrantAmt = "";

  //   if (value == null) {
  //     stateGrantAmt = undefined;
  //   } else {
  //     stateGrantAmt = value;
  //   }

  //   for (let index = 0; index < this.selectedUniversityList.length; index++) {
  //     let data = this.selectedUniversityList[index];

  //     let studentState = this.answerMap.get(6);
  //     if (
  //       stateCode.toLowerCase() == "mn" ||
  //       stateCode.toLowerCase() == "nj" ||
  //       studentState.value.toLowerCase() == stateCode.toLowerCase()
  //     ) {
  //     } else {
  //       let grantList = [];

  //       let stateGrant = {
  //         amount: stateGrantAmt,
  //         npcLink: "",
  //       };
  //       if (data.stateCode.toLowerCase() == stateCode.toLowerCase()) {
  //         this.configmap.getVirtueConfigData(
  //           `state_code_link_${stateCode.toLowerCase()}`,
  //           8889898,
  //           (resp) => {
  //             if (resp.length) {
  //               stateGrant.npcLink = resp[0].value;
  //             } else {
  //               stateGrant.npcLink =
  //                 "https://studentaid.gov/help-center/answers/article/state-aid";
  //             }
  //           }
  //         );
  //         grantList.push(stateGrant);
  //         this.selectedUniversityStateGrant[index] = grantList;
  //         this.stateGrantFieldValue[index] = stateGrant.amount;
  //         this.stateGrantFieldValue[index] = stateGrantAmt;
  //         this.setInterestPageAnswer(
  //           "stateGrant_" + stateCode.toLowerCase(),
  //           stateGrantAmt,
  //           [],
  //           data.name
  //         );
  //       }
  //     }
  //   }
  // }

  checkStateCalculatorExist(stateCode: string) {
    let stateCalculatorList = this.stateCalculatorList.filter(
      (el) => el.toLowerCase() == stateCode.toLowerCase()
    );

    if (stateCalculatorList.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  changeStateGrantAmount(
    stateCode: string,
    type: string,
    ipedsId: string,
    value: string
  ) {
    let stateGrantAmt = "";

    if (value == null) {
      stateGrantAmt = undefined;
    } else {
      stateGrantAmt = value;
    }

    for (let index = 0; index < this.selectedUniversityList.length; index++) {
      let data = this.selectedUniversityList[index];
      let studentState = this.answerMap.get(6);
      // stateCode.toLowerCase() == "mn" ||
      // stateCode.toLowerCase() == "nj" ||
      if (
        this.checkStateCalculatorExist(stateCode) ||
        studentState.value.toLowerCase() == stateCode.toLowerCase()
      ) {
      } else {
        let grantList = [];

        let stateGrant = {
          amount: stateGrantAmt,
          npcLink: "",
        };
        if (data.stateCode.toLowerCase() == stateCode.toLowerCase()) {
          if (type != "Change") {
            let sgAmt = this.CollegeSelctionList.get(
              "stateGrant_" + stateCode.toLowerCase()
            );

            if (sgAmt != undefined) {
              this.selectedUniversityStateGrant[index] = sgAmt.list;
              this.stateGrantFieldValue[index] = sgAmt.defaultValue;
            } else {
              this.configmap.getVirtueConfigData(
                `state_code_link_${stateCode.toLowerCase()}`,
                8889898,
                (resp) => {
                  if (resp.length) {
                    stateGrant.npcLink = resp[0].value;
                  } else {
                    stateGrant.npcLink =
                      "https://studentaid.gov/help-center/answers/article/state-aid";
                  }
                  grantList.push(stateGrant);
                  this.selectedUniversityStateGrant[index] = grantList;
                  this.stateGrantFieldValue[index] = stateGrantAmt;
                  this.selectedUniversityList[index][
                    "StudentSelectedCollege"
                  ].universityWiseStateGrant =
                    this.selectedUniversityStateGrant[index];
                }
              );
            }
          } else {
            this.configmap.getVirtueConfigData(
              `state_code_link_${stateCode.toLowerCase()}`,
              8889898,
              (resp) => {
                if (resp.length) {
                  stateGrant.npcLink = resp[0].value;
                } else {
                  stateGrant.npcLink =
                    "https://studentaid.gov/help-center/answers/article/state-aid";
                }
                // grantList.push(stateGrant);
                this.selectedUniversityStateGrant[index][0].amount =
                  stateGrantAmt;
                this.stateGrantFieldValue[index] = stateGrantAmt;

                this.selectedUniversityList[index][
                  "StudentSelectedCollege"
                ].universityWiseStateGrant =
                  this.selectedUniversityStateGrant[index];

                this.setInterestPageAnswer(
                  "stateGrant_" + stateCode.toLowerCase(),
                  stateGrantAmt,
                  this.selectedUniversityStateGrant[index],
                  data.name
                );
              }
            );
          }
        }
      }
    }
  }

  createAffinityQuestions(index: number, year: number) {
    let affinityQuestion =
      this.selectedUniversityList[index].yearWiseAffinityQuestion[year];
    for (let aindex = 0; aindex < affinityQuestion.length; aindex++) {
      const element = affinityQuestion[aindex];
      const selected = element?.AffinityQuestionSelectedOption;
      for (let opt = 0; opt < element.options.length; opt++) {
        const value = element.options[opt];

        if (value.value == selected) {
          this.selectedUniversityList[index].yearWiseAffinityQuestion[year][
            aindex
          ].options[opt]["selected"] = true;
        } else {
          this.selectedUniversityList[index].yearWiseAffinityQuestion[year][
            aindex
          ].options[opt]["selected"] = false;
        }
      }
    }
  }

  getAffinityQustionAnswerMap(index: string, option: number, curData: any) {
    let aindex = "aq" + index + "-" + option;
    this.affinityQuestionAnswer.set(aindex, curData);
    this.affinityQuestionAnswer = new Map(this.affinityQuestionAnswer);
    this.globalvar.affinityQuestionAnswer = this.affinityQuestionAnswer;
  }

  checkedStudentResidenceSelectedState(
    fieldType: string,
    index: number,
    ipedsId: string,
    statCode: string
  ) {
    // let checked: boolean = false;
    // let studentResidence = this.answerMap.get(6);
    if (fieldType == "domicileToggle") {
      let getStateAnswerMap = this.StateInOutMap.get("state" + statCode);
      if (getStateAnswerMap != undefined) {
        // if (
        //   getStateAnswerMap.stateCode == studentResidence.value &&
        //   getStateAnswerMap.stateInOut != "OUT_STATE"
        // ) {
        //   this.domesileStatus[index] = "IN_STATE";

        //   return true;
        // } else if (
        //   getStateAnswerMap.stateCode != studentResidence.value &&
        //   getStateAnswerMap.stateInOut != "OUT_STATE"
        // ) {
        //   this.domesileStatus[index] = "IN_STATE";
        //   return true;
        // } else {
        //   this.domesileStatus[index] = "OUT_STATE";
        //   return false;
        // }
        if (getStateAnswerMap.stateCode == statCode) {
          if (getStateAnswerMap.stateInOut == "IN_STATE") {
            this.domesileStatus[index] = "IN_STATE";
            return true;
          } else {
            this.domesileStatus[index] = "OUT_STATE";
            return false;
          }
        }
      }
    }
  }

  setStateInOutToggaleOptionsAnswerMap(
    fieldType: string,
    index: number,
    stateInOut: string,
    stateCode: string,
    defaultLabel: string
  ) {
    let ipedsId = this.selectedUniversityList[index].ipedsId;
    let getStateAnswerMap = this.StateInOutMap.get("state" + stateCode);
    if (getStateAnswerMap != undefined) {
      let stateAnswer = {
        stateCode: getStateAnswerMap.stateCode,
        stateInOut: stateInOut,
        defaultLabel: defaultLabel,
      };
      this.StateInOutMap.set("state" + stateCode, stateAnswer);
      this.StateInOutMap = new Map(this.StateInOutMap);
      this.globalvar.stateAnswerModel = this.StateInOutMap;
    }
  }

  selectDomicileAndResidency(
    fieldType: string,
    i: number,
    event: any,
    state_Code: string,
    ipedsId: string,
    manualchanged: string
  ) {
    this.globalvar.saveChangedDeduct = true;
    if (fieldType === "domicileToggleChange") {
      // if (event) {
      //   this.domesileStatus[index] = "IN_STATE";
      // } else {
      //   this.domesileStatus[index] = "OUT_STATE";
      // }
      let state = event == true ? "IN_STATE" : "OUT_STATE";

      if (state == "IN_STATE") {
        if (this.stateGrantFieldValue[i]) {
          this.changeStateGrantAmount(
            state_Code,
            "0",
            ipedsId,
            this.stateGrantFieldValue[i]
          );
        }
      }

      for (let index = 0; index < this.selectedUniversityList.length; index++) {
        // if(state=="OUT_STATE")
        // {
        //   this.universityWiseStateGrantManage(
        //     index,
        //     state,
        //     ipedsId
        //   );
        // }
        let data = this.selectedUniversityList[index];
        if (data.stateCode.toLowerCase() == state_Code.toLowerCase()) {
          this.domesileStatus[index] = state;
          const studentState = this.answerMap.get(6);
          // state_Code.toLowerCase() != "mn" &&
          // state_Code.toLowerCase() != "nj" &&
          if (
            this.checkStateCalculatorExist(state_Code) == false &&
            state_Code.toLowerCase() != studentState.value
          ) {
            this.universityWiseStateGrantManage(
              index,
              state,
              this.selectedUniversityList[index].ipedsId,
              this.selectedUniversityList[index].stateCode
            );
          }

          this.setStateInOutToggaleOptionsAnswerMap(
            fieldType,
            index,
            state,
            state_Code.toLowerCase(),
            manualchanged
          );

          this.setInterestPageAnswer(
            "SelectToggleInOut" + state_Code.toLowerCase(),
            this.domesileStatus[index],
            [],
            ""
          );

          // this.setInterestPageAnswer(
          //   "SelectToggleInOut" + state_Code.toLowerCase(),
          //   this.domesileStatus[index],
          //   [],
          //   ""
          // );
          this.getDataCampuseAndToggleValue(
            index,
            this.selectedUniversityList[index].ipedsId,
            ""
          );
        }
      }
    }

    if (fieldType === "residencyDropdownChange") {
      this.residencyStatus[i] = event;
      this.setInterestPageAnswer("r" + ipedsId, event, [], "");
      this.getDataCampuseAndToggleValue(i, ipedsId, "");
    }
  }

  changeInOutState(
    fieldType: string,
    index: number,
    event: any,
    ipedsId: string,
    state_code: string,
    changed: string
  ) {
    if (fieldType === "domicileToggle") {
      // let toggleOption = this.StateInOutMap.get("state" + state_code);
      // if (toggleOption != undefined) {
      //   this.domesileStatus[index] = toggleOption.stateInOut;
      // }
      // else
      //  {
      //   this.domesileStatus[index] = event;
      //   this.setStateInOutToggaleOptionsAnswerMap(
      //     fieldType,
      //     index,
      //     this.domesileStatus[index],state_code,changed);
      // }
      // stateCode.toLowerCase() != "mn" &&
      // stateCode.toLowerCase() != "nj" &&
      let studentState = this.answerMap.get(6);
      let stateCode = this.selectedUniversityList[index].stateCode;
      if (
        this.checkStateCalculatorExist(stateCode) == false &&
        studentState.value != stateCode.toLowerCase()
      ) {
        this.universityWiseStateGrantManage(
          index,
          this.domesileStatus[index],
          ipedsId,
          this.selectedUniversityList[index].stateCode
        );
      } else {
        this.selectedUniversityStateGrant[index] = undefined;
        // this.stateGrantFieldValue[index] = null;
      }
    }
  }

  universityWiseStateGrantManage(
    index: number,
    Instate: string,
    ipedsId: string,
    stateCode: string
  ) {
    let grantList = [];

    let stateGrant = {
      amount: "3120",
      npcLink: "",
    };
    if (Instate == "IN_STATE") {
      let studentStateCOde = this.answerMap.get(6);

      // stateCode.toLowerCase() == "mn" ||
      // stateCode.toLowerCase() == "nj" ||

      if (
        this.checkStateCalculatorExist(stateCode) == true ||
        studentStateCOde.value.toLowerCase() == stateCode.toLowerCase()
      ) {
        this.selectedUniversityStateGrant[index] = undefined;
      } else {
        let stateCode = this.selectedUniversityList[index].stateCode;
        let stGrant = this.CollegeSelctionList.get(
          "stateGrant_" + stateCode.toLowerCase()
        );

        if (stGrant != undefined) {
          this.selectedUniversityStateGrant[index] = stGrant.list;
          this.stateGrantFieldValue[index] = stGrant.defaultValue;

          if (this.selectedUniversityList[index]["StudentSelectedCollege"]) {
            this.selectedUniversityList[index][
              "StudentSelectedCollege"
            ].universityWiseStateGrant =
              this.selectedUniversityStateGrant[index];
          }

          // }
        } else {
          this.configmap.getVirtueConfigData(
            `state_code_link_${stateCode.toLowerCase()}`,
            8889898,
            (resp) => {
              if (resp.length) {
                stateGrant.npcLink = resp[0].value;
                if (resp[0].altValue) {
                  stateGrant.amount = resp[0].altValue;
                }
              } else {
                stateGrant.npcLink =
                  "https://studentaid.gov/help-center/answers/article/state-aid";
              }

              grantList.push(stateGrant);
              this.selectedUniversityStateGrant[index] = grantList;
              this.stateGrantFieldValue[index] = stateGrant.amount;
              if (
                this.selectedUniversityList[index]["StudentSelectedCollege"]
              ) {
                this.selectedUniversityList[index][
                  "StudentSelectedCollege"
                ].universityWiseStateGrant =
                  this.selectedUniversityStateGrant[index];

                this.setInterestPageAnswer(
                  "stateGrant_" + stateCode.toLowerCase(),
                  stateGrant.amount,
                  this.selectedUniversityStateGrant[index],
                  this.selectedUniversityList[index].name
                );
              }
            }
          );
        }
      }

      // }
    } else {
      this.selectedUniversityStateGrant[index] = undefined;
      // this.stateGrantFieldValue[index] = undefined;
      // this.setInterestPageAnswer(
      //   "stateGrant_"+ stateCode.toLowerCase(),
      //   undefined,
      //   [],
      //   ""
      // );
    }
  }

  changeResidencyCampuse(
    fieldType: string,
    index: number,
    event: any,
    ipedsId: string,
    changed: string
  ) {
    if (fieldType === "residencyDropdown") {
      let residenceOption = this.CollegeSelctionList.get("r" + ipedsId);
      if (residenceOption != undefined) {
        this.residencyStatus[index] = residenceOption.defaultValue;
      } else {
        this.residencyStatus[index] = event;
        this.setInterestPageAnswer("r" + ipedsId, event, [], "");
      }
    }
  }

  getDataCampuseAndToggleValue(
    index: number,
    ipedsId: any,
    isResirosity: string
  ) {
    let domicileAndResidencyStatus: string[] = [];
    domicileAndResidencyStatus[index] =
      this.domesileStatus[index] + "_" + this.residencyStatus[index];

    let affinityQuestion = null;

    let yearWiseAffinityQuestion = this.checkAffinityYearWiseAvailable(
      this.selectedUniversityList[index]?.yearWiseAffinityQuestion
    );
    if (yearWiseAffinityQuestion.length > 0) {
      affinityQuestion = yearWiseAffinityQuestion;
    }
    if (
      this.selectedUniversityList[index] != undefined &&
      this.domesileStatus[index] != undefined &&
      this.residencyStatus[index] != undefined
    ) {
      this.domesileStatus[index] + "_" + this.residencyStatus[index];
      let stateCode = this.selectedStates[index];
      let StudentSelectedCollege = {
        domicileAndResidency:
          this.domesileStatus[index] + "_" + this.residencyStatus[index],
        ipedsId: ipedsId,
        stateCode: stateCode,
        affinityQuestion: affinityQuestion,
        universityWiseStateGrant:
          this.selectedUniversityStateGrant[index] != undefined
            ? this.selectedUniversityStateGrant[index]
            : [],
      };
      this.selectedUniversityList[index]["StudentSelectedCollege"] =
        StudentSelectedCollege;
      this.spinnerService.show();
      this.apiService.getCollegeIpedsCost1(
        ipedsId,
        domicileAndResidencyStatus[index],
        this.selectedUniversityList[index].stateCode,
        (res) => {
          this.selectedUniversityList[index]["IPEDS_NPCCost"] = res;
          this.selectedUniversityList[index]["ipedsCost"] = res.IPEDS["costs"];
          this.selectedUniversityList[index]["npcCost"] = res.NPC["costs"];
          let costObj = {};

          Object.entries(res.IPEDS).forEach(([key, value]) => {
            if (key != "costs" && key != "dataAvailable") {
              costObj[`${key}`] = `${value}`;
            }
          });
          this.selectedUniversityList[index]["collegeIpedsCost"] = costObj;
          let npcObj = {};

          Object.entries(res.NPC).forEach(([key, value]) => {
            if (key != "costs" && key != "dataAvailable") {
              costObj[`${key}`] = `${value}`;
            }
          });

          this.selectedUniversityList[index]["collegeNPCCost"] = npcObj;

          if (isResirosity != "reciprocityState") {
            this.getMeritScholarShipCombindData(
              index,
              ipedsId,
              domicileAndResidencyStatus[index]
            );
          } else {
            this.hideSpinner();
          }
        }
      );
    }
  }

  getMeritScholarShipCombindData(
    collegeIndex: number,
    ipedsId: string,
    domicileAndResidencyStatus: string
  ) {
    let efc = this.answerMap.get(40);
    if (this.selectedUniversityList[collegeIndex]?.usingCSSProfile) {
      // console.log(this.affinityQuestionAnswer.get('aq' + collegeIndex + '-9999'), 'aq' + collegeIndex + '-9999', this.affinityQuestionAnswer.get('aq' + collegeIndex + '-9999')['9999']);
      if (
        this.affinityQuestionAnswer.get("aq" + ipedsId + "-9999") &&
        this.affinityQuestionAnswer.get("aq" + ipedsId + "-9999")["9999"]
          .amount != ""
      ) {
        efc = {
          value:
            this.affinityQuestionAnswer.get("aq" + ipedsId + "-9999")["9999"]
              .amount ?? 0,
          fieldNo: 0,
          type: InputType.TEXT,
          parentwidgetno: 0,
          altValue: "",
          label: "",
        };
      }
    }
    // let act = this.answerMap.get(202);

    let gpa = "";
    let gpaScale = this.answerMap.get(266);
    let actdropdown = this.answerMap.get(32);
    let act = "";
    let sat = "";
    if (actdropdown.value == "act") {
      let scoreact = this.answerMap.get(202);
      act = scoreact.value;
    }
    if (actdropdown.value == "sat") {
      let scoresct = this.answerMap.get(201);
      sat = scoresct.value;
    }
    if (gpaScale.value == "4") {
      let gpaValue = this.answerMap.get(31);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "5") {
      let gpaValue = this.answerMap.get(274);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "12") {
      let gpaValue = this.answerMap.get(275);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "100") {
      let gpaValue = this.answerMap.get(276);
      gpa = gpaValue.value;
    }
    let state = this.answerMap.get(6);

    let domesileStatus = this.domesileStatus[collegeIndex];
    const combinedAidRequest = {
      pagination: {
        totalSize: 0,
        pageNo: 0,
      },
      ipedsId: ipedsId,
      efc: efc.value,
      act: act,
      sat: sat,
      gpa: gpa,
      gpaScale: gpaScale?.value,
      studentEnrollmentStatus: "FULL_TIME",
      studentStateCode: state.value,
      domicileAndResidency: domicileAndResidencyStatus,
      preferOutStateGrid: domesileStatus == "OUT_STATE" ? true : false,
    };

    this.apiService.getMeritScholarShipCombindData1(
      ipedsId,
      efc.value,
      act,
      sat,
      gpa,
      gpaScale?.value,
      state.value,
      domicileAndResidencyStatus,
      this.domesileStatus[collegeIndex],
      (meritData) => {
        if (this.selectedUniversityList[collegeIndex]?.ipedsId == ipedsId) {
          this.selectedUniversityList[collegeIndex]["result"] = meritData;
          this.selectedUniversityList[collegeIndex][
            "result"
          ].preferOutStateGrid = combinedAidRequest?.preferOutStateGrid;
          this.selectedUniversityList[collegeIndex]["combinedAidRequest"] =
            combinedAidRequest;
          this.selectedUniversityList[collegeIndex]["combinedAidResponse"] =
            meritData;
          // this.hideSpinner();
          // this.handleNextBtnDisable = false;
          this.setByCourseCollegeWiseProgramList(collegeIndex, ipedsId);
          //  return meritData;
        }
      }
    );
  }

  setByCourseCollegeWiseProgramList(index: number, ipedsId: string) {
    let studentProgram = this.answerMap.get(35);
    // if (studentProgram.value !="0") {
    this.apiService.getCollegeWiseProgramData1(
      ipedsId,
      studentProgram.value,
      (ProgramList) => {
        if (ProgramList?.collegeDataPresent == true) {
          this.selectedUniversityList[index]["CollegeWiseProgramList"] =
            ProgramList;
        }
        // this.IsLoadData = false;
        this.hideSpinner();
      }
    );
    // } else {
    //   this.hideSpinner();
    // }
  }

  getCampusOption(clg: any) {
    if (clg && clg?.housingNotAvailable == true) {
      this.residenceOptions = [];
      this.residenceOptions = this.housingNotAvailableOption;
    } else {
      this.residenceOptions = [];
      this.residenceOptions = this.housingAvailableOption;
    }
    return this.residenceOptions;
  }

  previous() {
    this.globalvar.initialiseStateMapSubjectBehaviour();
    let pno = --this.globalvar.stepper.page;
    this.globalvar.redirectPage(pno, true, false, false);
    this.eventDataService.hanleAnswerMap(this.answerMap);
  }

  next() {
    this.globalvar.initialiseStateMapSubjectBehaviour();
    if (this.checkUserLogin.clickActionToCheckLogout() == true) {
      this.spinnerService.show();

      if (this.globalvar.saveChangedDeduct == true) {
        this.apiService.getFormFilledCallBack(
          this.globalvar.formSubmitId,
          (response: FormResponse) => {
            this.globalvar.formResponse = response;

            this.apiService.submitForm(
              this.answerMap,
              0,
              false,
              "TOP5",
              (resp) => {
                let formSubmitId = resp["id"];
                this.globalvar.formSubmitId = resp["id"];
                this.globalvar.formResponse = resp;
                this.globalvar.formFilledSubmitID = resp["id"];

                let selectedColleges = [];
                let selectedCollegeLogs = [];
                let usingCSSProfile = "";
                for (
                  let index = 0;
                  index < this.selectedUniversityList.length;
                  index++
                ) {
                  if (
                    this.selectedUniversityList[index] &&
                    this.selectedUniversityList[index]?.ipedsId != undefined
                  ) {
                    let affinityQuestion = null;
                    let name = this.selectedUniversityList[index]["name"];
                    let aidRequest = {};
                    let calculatedAids = {};
                    let costLog = {};
                    if (
                      this.selectedUniversityList[index]?.combinedAidRequest
                    ) {
                      aidRequest =
                        this.selectedUniversityList[index]?.combinedAidRequest;
                    }
                    if (
                      this.selectedUniversityList[index]?.combinedAidResponse
                    ) {
                      calculatedAids =
                        this.selectedUniversityList[index]?.combinedAidResponse;
                    }

                    if (this.selectedUniversityList[index]?.collegeIpedsCost) {
                      costLog =
                        this.selectedUniversityList[index]?.collegeIpedsCost;
                    }

                    let stateCode = this.selectedStates[index];
                    let ipedsId = this.selectedUniversityList[index]["ipedsId"];

                    let yearWiseAffinityQuestion =
                      this.checkAffinityYearWiseAvailable(
                        this.selectedUniversityList[index]
                          ?.yearWiseAffinityQuestion
                      );
                    if (yearWiseAffinityQuestion.length > 0) {
                      affinityQuestion = yearWiseAffinityQuestion;
                    }

                    if (this.selectedUniversityList[index]?.usingCSSProfile) {
                      if (this.efcFieldValue[index]) {
                        usingCSSProfile = this.efcFieldValue[index];
                      }
                    }

                    let awardLetterResultId = "";
                    if (this.ocrResponseListTotal[index] != undefined) {
                      awardLetterResultId = this.ocrResponseListTotal[index].id;
                    }

                    let domicileAndResidency =
                      this.domesileStatus[index] +
                      "_" +
                      this.residencyStatus[index];
                    let collegeSelction =
                      this.selectedUniversityList[index][
                        "StudentSelectedCollege"
                      ];

                    let submissionLogs = {
                      name: name,
                      stateCode: stateCode,
                      ipedsId: ipedsId,
                      domicileAndResidency: domicileAndResidency,
                      affinityQuestions: affinityQuestion,
                      aidRequest: aidRequest,
                      calculatedAids: calculatedAids,
                      extraData: costLog,
                      awardLetterResultId: awardLetterResultId,
                    };

                    selectedCollegeLogs.push(submissionLogs);

                    // Start Store Data For handle In Extra Data For Comparison Page

                    let choiseCollege = {
                      name: name,
                      stateCode: stateCode,
                      ipedsId: ipedsId,
                      domicileAndResidency: domicileAndResidency,
                      affinityQuestions: affinityQuestion,
                      usingCSSProfile: usingCSSProfile,
                      calculatedAids: calculatedAids,
                      awardLetterResultId: awardLetterResultId,
                      collegeSelections: collegeSelction,
                    };
                    selectedColleges.push(choiseCollege);
                  }
                }

                let CollegeSelctionList = {},
                  filterSelected = {},
                  affinityQuestionAnswer = {},
                  stateAnswerModel = {},
                  filterPageCollegeMap = {};

                CollegeSelctionList = JSON.stringify([
                  ...this.globalvar.CollegeSelctionList,
                ]);
                filterSelected = JSON.stringify([
                  ...this.globalvar.filterSelected,
                ]);
                affinityQuestionAnswer = JSON.stringify([
                  ...this.globalvar.affinityQuestionAnswer,
                ]);
                stateAnswerModel = JSON.stringify([
                  ...this.globalvar.stateAnswerModel,
                ]);
                filterPageCollegeMap = JSON.stringify([
                  ...this.globalvar.interestPageAnswerMap,
                ]);

                let StudentList = {
                  internationalStudent: this.globalvar.isInternatinalStudent,
                  top5_request: true,
                  formfilledId: this.globalvar.formFilledSubmitID,
                  SelectCollege: selectedColleges,
                  answerMapCollegeSelections: CollegeSelctionList,
                  answerMapCollegeFiltersFilter: filterSelected,
                  answerMapaffinityQuestionAnswer: affinityQuestionAnswer,
                  answerMapCollegeStateInOutMap: stateAnswerModel,
                  filterPageCollegeMap: filterPageCollegeMap,
                };
                // End Store Data For handle In Extra Data

                let submissionsUrl = {
                  internationalStudent: this.globalvar.isInternatinalStudent,
                  top5_request: true,
                  formfilledId: this.globalvar.formFilledSubmitID,
                  SelectCollege: "",
                };

                const extraData = JSON.stringify(StudentList);
                var encrypted = this.EncryptDecrpt.set(
                  "govirtue@123",
                  JSON.stringify(submissionsUrl)
                );
                const encrypted_split = encrypted.split("/");
                const ect_string = encrypted_split.join("***");
                let hostname = "";

                if (
                  window.location.hostname == "tech.virtueanalytics.com" ||
                  window.location.hostname == "localhost"
                ) {
                  hostname =
                    "https://tech.virtueanalytics.com/top5App/home/login/0/";
                } else {
                  hostname =
                    "https://" +
                    window.location.hostname +
                    "/top5/home/login/0/";
                }

                const submissionReportLink = hostname + ect_string;
                // hostname + "/top5/home/login/0/" + ect_string;
                this.globalvar.submissionReportLink = submissionReportLink;
                this.apiService.top5UserSubmission(
                  formSubmitId,
                  selectedCollegeLogs,
                  submissionReportLink,
                  extraData,
                  (resp) => {
                    if (resp) {
                      this.sendSelectedUniversityData();
                      let pno = 8;
                      // let pno = ++this.globalvar.stepper.page;
                      this.globalvar.redirectPage(pno, true, false, false);
                      this.globalvar.saveChangedDeduct = false;
                      this.eventDataService.hanleAnswerMap(this.answerMap);
                      this.hideSpinner();
                    }
                  }
                );
              }
            );
          }
        );
      } else {
        this.sendSelectedUniversityData();
        // let pno = ++this.globalvar.stepper.page;
        let pno = 8;
        this.globalvar.redirectPage(pno, true, false, false);
        this.eventDataService.hanleAnswerMap(this.answerMap);
        this.hideSpinner();
      }
    }
  }

  openCollegeProfile(index: number) {
    console.log(
      this.selectedUniversityList[index].enrollmentType,
      "sipfpfpogsogfjdfjgfjdfjj"
    );
    let mergerdUniversityList = [];
    let obj = {} as any;
    let dropDownDataObject = {} as any;
    if (this.selectedUniversityList[index]["collegeRankInUS"]) {
      obj.collegeRankInUS =
        this.selectedUniversityList[index]["collegeRankInUS"];
    }
    obj.name = this.selectedUniversityList[index]["name"];
    obj.result = this.selectedUniversityList[index]["result"];
    dropDownDataObject = { dropDownData: obj };
    mergerdUniversityList[0] = dropDownDataObject;
    let objSummary = {} as any;
    //let summaryDataObject = {} as any;
    if (this.selectedUniversityList[index].selectedcssProfile != undefined) {
      objSummary.cssProfileEFC =
        this.selectedUniversityList[index]?.selectedcssProfile;
    }
    objSummary.collegeProfileIcon =
      this.selectedUniversityList[index]?.collegeProfileIcon;
    objSummary.enrollmentType =
      this.selectedUniversityList[index]?.enrollmentType;
    objSummary.imageAvailable =
      this.selectedUniversityList[index]?.imageAvailable;
    objSummary.defaultLabelColor =
      this.selectedUniversityList[index]?.defaultLabelColor;
    objSummary.lastSupportedSession =
      this.selectedUniversityList[index]["lastSupportedSession"];
    objSummary.dataCollectionTime =
      this.selectedUniversityList[index]["dataCollectionTime"];

    if (this.selectedUniversityList[index]?.importantLink?.npc) {
      objSummary.npcLink =
        this.selectedUniversityList[index]["importantLink"]["npc"];
    } else {
      objSummary.npcLink = null;
    }
    if (this.selectedUniversityList[index]?.importantLink?.financialAid) {
      objSummary.financialAid =
        this.selectedUniversityList[index]["importantLink"]["financialAid"];
    } else {
      objSummary.financialAid = null;
    }

    if (this.selectedUniversityList[index]?.importantLink?.website) {
      objSummary.website =
        this.selectedUniversityList[index]["importantLink"]["website"];
    } else {
      objSummary.website = null;
    }

    if (this.selectedUniversityList[index]?.contact?.contactNumber) {
      objSummary.contact =
        this.selectedUniversityList[index]["contact"]["contactNumber"];
    } else {
      objSummary.contact = null;
    }
    if (this.selectedUniversityList[index]?.contact?.address) {
      objSummary.address =
        this.selectedUniversityList[index]["contact"]["address"];
    } else {
      objSummary.address = null;
    }

    let year = this.commonHandler.getyearWiseCollegeData(
      this.selectedUniversityList[index]?.yearWiseCollegeData,
      this.year
    );
    if (
      this.selectedUniversityList[index]?.yearWiseCollegeData == ({} as object)
    ) {
      objSummary.inStateTutionFee = null;
      objSummary.outStateTutionFee = null;
      objSummary.basedOnCollegeWebsite = 0;
    } else {
      if (
        !this.selectedUniversityList[index]["yearWiseCollegeData"] ||
        !this.selectedUniversityList[index]["yearWiseCollegeData"][year]
      ) {
        // objSummary.basedOnCollegeWebsite = this.setBasedOnWebsiteAmount(
        //   this.selectedUniversityList[index]["datafields"],domicileAndResidency);
        const inStateTutionFee = this.selectedUniversityList[index][
          "datafields"
        ].find((element) => element.fieldNo == 51);
        if (inStateTutionFee) {
          objSummary.inStateTutionFee = inStateTutionFee["value"];
        }
        const outStateTutionFee = this.selectedUniversityList[index][
          "datafields"
        ].find((element) => element.fieldNo == 135);
        if (outStateTutionFee) {
          objSummary.outStateTutionFee = outStateTutionFee["value"];
        }
      } else {
        if (
          this.selectedUniversityList[index] &&
          this.selectedUniversityList[index]["yearWiseCollegeData"] !=
            ({} as object) &&
          this.selectedUniversityList[index]["yearWiseCollegeData"][year]
        ) {
          // objSummary.basedOnCollegeWebsite = this.setBasedOnWebsiteAmount(
          //   this.selectedUniversityList[index]["yearWiseCollegeData"][year],
          //   domicileAndResidency
          // );
          const data51 = this.selectedUniversityList[index][
            "yearWiseCollegeData"
          ][year].find((element) => element.fieldNo == 51);
          if (data51) {
            objSummary.inStateTutionFee = data51["value"];
          }
          const data = this.selectedUniversityList[index][
            "yearWiseCollegeData"
          ][year].find((element) => element.fieldNo == 135);
          if (data) {
            objSummary.outStateTutionFee = data["value"];
          }
        }
      }
    }
    mergerdUniversityList[0]["summaryData"] = objSummary;
    this.OpenUniversitySummaryDialog(mergerdUniversityList[0]);
  }

  OpenUniversitySummaryDialog(university: any) {
    this.openUniversitySummaryDialog = this.dialogService.open<any>(
      new PolymorpheusComponent(CollegeprofileComponent, this.injector),
      {
        data: university,
        dismissible: false,
      }
    );
    this.openUniversitySummaryDialog.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
  }

  private openUniversitySummaryDialog = this.dialogService.open<any>(
    new PolymorpheusComponent(CollegeprofileComponent, this.injector),
    {
      data: "",
      dismissible: false,
      label: "ToolTip",
      // size: "auto",
    }
  );
  sendSelectedUniversityData() {
    this.mergerdUniversityList = [];
    let searchExtraCollegeList = [];
    let searchCollege = [];
    if (
      this.selectedUniversityList.length > 5 ||
      this.selectedUniversityList.length <= 5
    ) {
      for (let index = 0; index < this.selectedUniversityList.length; index++) {
        if (this.selectedUniversityList[index] == undefined) continue;
        let obj = {} as any;
        let dropDownDataObject = {} as any;

        if (this.selectedUniversityList[index]["collegeRankInUS"]) {
          obj.collegeRankInUS =
            this.selectedUniversityList[index]["collegeRankInUS"];
        }
        obj.id = this.selectedUniversityList[index]["id"];
        obj.name = this.selectedUniversityList[index]["name"];
        obj.StudentSelectedCollege =
          this.selectedUniversityList[index]["StudentSelectedCollege"];

        if (
          this.selectedUniversityList[index]["ROIDataCollegeWiseAllProgram"] !=
          undefined
        ) {
          obj.ROIDataCollegeWiseAllProgram =
            this.selectedUniversityList[index]["ROIDataCollegeWiseAllProgram"];
        } else {
          obj.ROIDataCollegeWiseAllProgram = null;
        }
        obj.ipedsId = this.selectedUniversityList[index]["ipedsId"];
        obj.costOfAttendance = this.selectedUniversityList[index]["ipedsCost"];
        obj.IPEDSNPC = this.selectedUniversityList[index]["IPEDS_NPCCost"];

        obj.npcCollegeCostProfile =
          this.selectedUniversityList[index]["npcCost"];
        obj.result = this.selectedUniversityList[index]["result"];
        obj.combinedAidRequest =
          this.selectedUniversityList[index]["combinedAidRequest"];

        if (
          this.selectedUniversityList[index].selectedcssProfile != undefined
        ) {
          obj.cssProfileEFC =
            this.selectedUniversityList[index]?.selectedcssProfile;
        }

        if (searchExtraCollegeList.length > 0) {
          if (searchCollege.length == 0) {
            searchCollege = searchExtraCollegeList;
            obj.searchExtraCollegeList = searchCollege;
          }
        }
        if (
          this.selectedUniversityList[index]["CollegeWiseProgramList"] !=
          undefined
        ) {
          obj.CollegeWiseProgramList =
            this.selectedUniversityList[index]["CollegeWiseProgramList"];
        }

        let domicileAndResidency =
          this.domesileStatus[index] + "_" + this.residencyStatus[index];

        obj.yearWiseAffinityQuestion =
          this.selectedUniversityList[index]["yearWiseAffinityQuestion"];

        for (const item of this.selectedUniversityList[index]["ipedsCost"]) {
          obj[item.name] = item.value;
        }

        if (
          this.selectedUniversityList[index]["analysisData"] != null &&
          this.selectedUniversityList[index]["analysisData"]
        ) {
          // this.selectedUniversityList[index]["analysisData"].admissionsRate =
          //   this.getAcceptanceRatevirtue(
          //     this.selectedUniversityList[index]?.ipedsId,
          //     index
          //   );

          // this.selectedUniversityList[index][
          //   "analysisData"
          // ].yearWiseCollegeROIData["2022"].admissionsRate =
          //   this.getAcceptanceRatevirtue(
          //     this.selectedUniversityList[index]?.ipedsId,
          //     index
          //   );
          // // getGraduationRate from VirtueData
          // this.selectedUniversityList[index][
          //   "analysisData"
          // ].yearWiseCollegeROIData["2022"].graduationRate =
          //   this.getGratuationRatevirtue(
          //     this.selectedUniversityList[index]?.ipedsId,
          //     index
          //   );

          // if yearWiseCollegeROIData not preent

          if (
            Object.keys(
              this.selectedUniversityList[index]["analysisData"][
                "yearWiseCollegeROIData"
              ]
            ).length === 0
          ) {
            this.selectedUniversityList[index]["analysisData"][
              "yearWiseCollegeROIData"
            ]["year"] = {
              admissionsRate: this.getAcceptanceRatevirtue(
                this.selectedUniversityList[index]?.ipedsId,
                index
              ),

              graduationRate: this.getGratuationRatevirtue(
                this.selectedUniversityList[index]?.ipedsId,
                index
              ),
            };
            this.selectedUniversityList[index]["analysisData"].admissionsRate =
              this.getAcceptanceRatevirtue(
                this.selectedUniversityList[index]?.ipedsId,
                index
              );

            // when yearWiseCollegeROIData is present
          }
          // If yearWiseCollegeROIData["2022"] already has data, update admissionsRate
          // this.selectedUniversityList[index]["analysisData"].admissionsRate =
          //   this.getAcceptanceRatevirtue(
          //     this.selectedUniversityList[index]?.ipedsId,
          //     index
          //   );
          // this.selectedUniversityList[index]["analysisData"][
          //   "yearWiseCollegeROIData"
          // ]["2022"].admissionsRate = this.getAcceptanceRatevirtue(
          //   this.selectedUniversityList[index]?.ipedsId,
          //   index
          // );
          // this.selectedUniversityList[index][
          //   "analysisData"
          // ].yearWiseCollegeROIData["2022"].graduationRate =
          //   this.getGratuationRatevirtue(
          //     this.selectedUniversityList[index]?.ipedsId,
          //     index
          //   );

          Object.entries(
            this.selectedUniversityList[index]["analysisData"]
          ).map((entry) => {
            let key = entry[0];
            let value = entry[1];
            obj[key] = value;
            if (key == "yearWiseCollegeROIData" && value) {
              let yearWiseData = this.getCollegeROIData(value);
              value["year"] = yearWiseData;
              console.log(value["year"], "yearwisedata");

              if (
                this.selectedUniversityList[index]["analysisData"]
                  .admissionsRate
              ) {
                value["year"].admissionsRate = this.getAcceptanceRatevirtue(
                  this.selectedUniversityList[index]?.ipedsId,
                  index
                );
                value["year"].graduationRate = this.getGratuationRatevirtue(
                  this.selectedUniversityList[index]?.ipedsId,
                  index
                );
                // value["2022"].admissionsRate =this.selectedUniversityList[index]["analysisData"].admissionsRate;
                obj[key] = value;
              } else {
                //  value["year"]=yearWiseData;
                value["year"].admissionsRate = this.getAcceptanceRatevirtue(
                  this.selectedUniversityList[index]?.ipedsId,
                  index
                );
                value["year"].graduationRate = this.getGratuationRatevirtue(
                  this.selectedUniversityList[index]?.ipedsId,
                  index
                );
                // value["2022"].admissionsRate = 0;
                obj[key] = value;
              }
            }
          });
        } else {
          let ROIDataObj = JSON.stringify(
            this.predefineArray.yearWiseCollegeROIDataObj
          );

          let yearData = JSON.parse(ROIDataObj);
          yearData["year"].admissionsRate = this.getAcceptanceRatevirtue(
            this.selectedUniversityList[index]?.ipedsId,
            index
          );
          yearData["year"].graduationRate = this.getGratuationRatevirtue(
            this.selectedUniversityList[index]?.ipedsId,
            index
          );

          obj.yearWiseCollegeROIData = yearData;
        }

        dropDownDataObject = { dropDownData: obj };
        this.mergerdUniversityList[index] = dropDownDataObject;

        let objSummary = {} as any;
        //let summaryDataObject = {} as any;
        if (
          this.selectedUniversityList[index].selectedcssProfile != undefined
        ) {
          objSummary.cssProfileEFC =
            this.selectedUniversityList[index]?.selectedcssProfile;
        }
        objSummary.collegeProfileIcon =
          this.selectedUniversityList[index]?.collegeProfileIcon;
        objSummary.enrollmentType =
          this.selectedUniversityList[index]?.enrollmentType;
        objSummary.imageAvailable =
          this.selectedUniversityList[index]?.imageAvailable;
        objSummary.defaultLabelColor =
          this.selectedUniversityList[index]?.defaultLabelColor;
        objSummary.lastSupportedSession =
          this.selectedUniversityList[index]["lastSupportedSession"];
        objSummary.dataCollectionTime =
          this.selectedUniversityList[index]["dataCollectionTime"];

        if (this.selectedUniversityList[index]?.importantLink?.npc) {
          objSummary.npcLink =
            this.selectedUniversityList[index]["importantLink"]["npc"];
        } else {
          objSummary.npcLink = null;
        }
        if (this.selectedUniversityList[index]?.importantLink?.financialAid) {
          objSummary.financialAid =
            this.selectedUniversityList[index]["importantLink"]["financialAid"];
        } else {
          objSummary.financialAid = null;
        }

        if (this.selectedUniversityList[index]?.importantLink?.website) {
          objSummary.website =
            this.selectedUniversityList[index]["importantLink"]["website"];
        } else {
          objSummary.website = null;
        }

        if (this.selectedUniversityList[index]?.contact?.contactNumber) {
          objSummary.contact =
            this.selectedUniversityList[index]["contact"]["contactNumber"];
        } else {
          objSummary.contact = null;
        }
        if (this.selectedUniversityList[index]?.contact?.address) {
          objSummary.address =
            this.selectedUniversityList[index]["contact"]["address"];
        } else {
          objSummary.address = null;
        }

        let year = this.commonHandler.getyearWiseCollegeData(
          this.selectedUniversityList[index]?.yearWiseCollegeData,
          this.year
        );
        if (
          this.selectedUniversityList[index]?.yearWiseCollegeData ==
          ({} as object)
        ) {
          objSummary.inStateTutionFee = null;
          objSummary.outStateTutionFee = null;
          objSummary.basedOnCollegeWebsite = 0;
        } else {
          if (
            !this.selectedUniversityList[index]["yearWiseCollegeData"] ||
            !this.selectedUniversityList[index]["yearWiseCollegeData"][year]
          ) {
            objSummary.basedOnCollegeWebsite = this.setBasedOnWebsiteAmount(
              this.selectedUniversityList[index]["datafields"],
              domicileAndResidency
            );
            const inStateTutionFee = this.selectedUniversityList[index][
              "datafields"
            ].find((element) => element.fieldNo == 51);
            if (inStateTutionFee) {
              objSummary.inStateTutionFee = inStateTutionFee["value"];
            }
            const outStateTutionFee = this.selectedUniversityList[index][
              "datafields"
            ].find((element) => element.fieldNo == 135);
            if (outStateTutionFee) {
              objSummary.outStateTutionFee = outStateTutionFee["value"];
            }
          } else {
            if (
              this.selectedUniversityList[index] &&
              this.selectedUniversityList[index]["yearWiseCollegeData"] !=
                ({} as object) &&
              this.selectedUniversityList[index]["yearWiseCollegeData"][year]
            ) {
              objSummary.basedOnCollegeWebsite = this.setBasedOnWebsiteAmount(
                this.selectedUniversityList[index]["yearWiseCollegeData"][year],
                domicileAndResidency
              );
              const data51 = this.selectedUniversityList[index][
                "yearWiseCollegeData"
              ][year].find((element) => element.fieldNo == 51);
              if (data51) {
                objSummary.inStateTutionFee = data51["value"];
              }
              const data = this.selectedUniversityList[index][
                "yearWiseCollegeData"
              ][year].find((element) => element.fieldNo == 135);
              if (data) {
                objSummary.outStateTutionFee = data["value"];
              }
            }
          }
        }

        this.mergerdUniversityList[index]["summaryData"] = objSummary;
      }
    }
    for (let index = 0; index < this.ocrResponseListTotal.length; index++) {
      let ocrDataScholarshipItems = {} as any;
      let ocrDataCoaItems = {} as any;
      let additionOfDetectedScholarshipValues: number = 0;
      let additionOfDetectedCoaValues: number = 0;
      let additionOfDetectedScholarshipValuesEdited: number = 0;
      let additionOfDetectedCoaValuesEdited: number = 0;
      let totalCoaIndex = -1;
      let totalAidIndex = -1;

      if (this.ocrResponseListTotal[index] == undefined) continue;
      ocrDataCoaItems = this.createOcrDataObject(
        this.ocrResponseListTotal[index],
        "1"
      );
      ocrDataScholarshipItems = this.createOcrDataObject(
        this.ocrResponseListTotal[index],
        "2"
      );
      totalCoaIndex = this.ocrResponseListTotal[index][
        "detectedValues"
      ].findIndex((elem) => {
        return elem.fieldId == 501;
      });
      totalAidIndex = this.ocrResponseListTotal[index][
        "detectedValues"
      ].findIndex((elem) => {
        return elem.fieldId == 601;
      });

      if (totalCoaIndex > -1 || totalAidIndex > -1) {
        additionOfDetectedScholarshipValuesEdited =
          this.ocrResponseListTotal[index]["detectedValues"][totalAidIndex]
            .value;
        additionOfDetectedCoaValuesEdited =
          this.ocrResponseListTotal[index]["detectedValues"][totalCoaIndex]
            .value;
      } else {
        for (const item of this.ocrResponseListTotal[index]["detectedValues"]) {
          if (item.mapWith === "1") {
            additionOfDetectedCoaValues += +item.value;
          } else if (item.mapWith === "2") {
            additionOfDetectedScholarshipValues += +item.value;
          }
        }
      }

      for (
        let indexMerged = 0;
        indexMerged < this.mergerdUniversityList.length;
        indexMerged++
      ) {
        if (this.mergerdUniversityList[indexMerged] == undefined) continue;
        if (
          ocrDataScholarshipItems.id ===
          this.mergerdUniversityList[indexMerged]["dropDownData"].id
        ) {
          if (ocrDataCoaItems != undefined) {
            this.mergerdUniversityList[indexMerged]["ocrDataCoaItems"] =
              ocrDataCoaItems;
          }
          // if (ocrDataScholarshipItems != undefined && totalAidIndex == -1) {
          this.mergerdUniversityList[indexMerged]["ocrDataScholarshipItems"] =
            ocrDataScholarshipItems;
          // }
          this.mergerdUniversityList[indexMerged]["ocrDataCoaSum"] =
            additionOfDetectedCoaValues;
          this.mergerdUniversityList[indexMerged]["ocrDataScholarshipsSum"] =
            additionOfDetectedScholarshipValues;
          this.mergerdUniversityList[indexMerged]["ocrDataCoaSumEdited"] =
            additionOfDetectedCoaValuesEdited;
          this.mergerdUniversityList[indexMerged][
            "ocrDataScholarshipsSumEdited"
          ] = additionOfDetectedScholarshipValuesEdited;
          this.mergerdUniversityList[indexMerged]["ocrDataOutOfPocketEdited"] =
            additionOfDetectedCoaValuesEdited -
              additionOfDetectedScholarshipValuesEdited >
            0
              ? additionOfDetectedCoaValuesEdited -
                additionOfDetectedScholarshipValuesEdited
              : 0;
        }
      }
    }

    if (this.mergerdUniversityList.length > 5) {
      searchExtraCollegeList = [...this.mergerdUniversityList];
      // let mergedStr = JSON.stringify(this.mergerdUniversityList);
      // searchExtraCollegeList = JSON.parse(mergedStr);
      this.mergerdUniversityList.splice(5, this.mergerdUniversityList.length);
      console.log(this.mergerdUniversityList, "mergeUniversityList");
      searchExtraCollegeList.splice(0, 5);
      console.log(searchExtraCollegeList, "searchExtraCollegeList");
      this.mergerdUniversityList[0].SearchCollegeFilterList =
        searchExtraCollegeList;
    } else {
      if (this.mergerdUniversityList.length <= 5) {
        this.mergerdUniversityList[0].SearchCollegeFilterList = [];
      }
    }
    let mergerdUniversityListOnlyNotEmpty = this.mergerdUniversityList.filter(
      (element) => element != "empty"
    );

    console.log(mergerdUniversityListOnlyNotEmpty);

    this.optionData.emit(mergerdUniversityListOnlyNotEmpty);
  }

  setBasedOnWebsiteAmount(collegeData: any, residenceInOutState: string) {
    let collegeWebsiteAmount = 0;
    const inStateTutionFee = collegeData.find(
      (element) => element?.fieldNo == 51
    );
    const outStateTutionFee = collegeData.find(
      (element) => element?.fieldNo == 135
    );
    const coa = collegeData.find((element) => element?.fieldNo == 50);
    const roomAndBoardFee = collegeData.find(
      (element) => element?.fieldNo == 136
    );

    // const outStateCOA = collegeData.find((element) => element?.fieldNo == 330);

    if (
      (residenceInOutState == "IN_STATE_ON_CAMPUS" ||
        residenceInOutState == "IN_STATE_OFF_CAMPUS_NOT_FAMILY") &&
      coa?.value
    ) {
      collegeWebsiteAmount = coa?.value;
    }
    // if(residenceInOutState=="IN_STATE_OFF_CAMPUS_NOT_FAMILY" && coa?.value && roomAndBoardFee?.value)
    // {
    //   collegeWebsiteAmount=coa.value;
    // }
    if (
      residenceInOutState == "IN_STATE_OFF_CAMPUS_FAMILY" &&
      coa?.value &&
      roomAndBoardFee?.value
    ) {
      collegeWebsiteAmount =
        Number(coa?.value) - Number(roomAndBoardFee?.value);
    }
    if (
      (residenceInOutState == "OUT_STATE_ON_CAMPUS" ||
        residenceInOutState == "OUT_STATE_OFF_CAMPUS_NOT_FAMILY") &&
      coa?.value
    ) {
      // coa -inStateTutionFee + outStateTutionFee
      let outStateFee = outStateTutionFee?.value
        ? outStateTutionFee?.value
        : inStateTutionFee?.value;
      let InStateFee = inStateTutionFee?.value
        ? inStateTutionFee?.value
        : outStateTutionFee?.value;
      collegeWebsiteAmount =
        Number(coa?.value) -
        Number(InStateFee ? InStateFee : 0) +
        Number(outStateFee ? outStateFee : 0);
    }

    // if(residenceInOutState=="OUT_STATE_OFF_CAMPUS_NOT_FAMILY")
    // {
    //   collegeWebsiteAmount=coa.value - inStateTutionFee.value + outStateTutionFee.value
    // }

    if (residenceInOutState == "OUT_STATE_OFF_CAMPUS_FAMILY" && coa?.value) {
      let outStateFee = outStateTutionFee?.value
        ? outStateTutionFee?.value
        : inStateTutionFee?.value;
      let InStateFee = inStateTutionFee?.value
        ? inStateTutionFee?.value
        : outStateTutionFee?.value;
      collegeWebsiteAmount =
        Number(coa?.value) -
        Number(InStateFee ? InStateFee : 0) +
        Number(outStateFee ? outStateFee : 0) -
        Number(roomAndBoardFee?.value);
    }
    return collegeWebsiteAmount;
  }

  closeFile() {
    this.fileUploadArray[0].fileIds = [];
  }

  createOcrDataObject(ocrDataItem, mapIdValue: string) {
    let obj = {} as any;
    let selectedUniversityItem = this.selectedUniversityList.find(
      (item) => item != undefined && item.name == ocrDataItem.extraText
    );
    obj.id = selectedUniversityItem["id"];
    obj.name = selectedUniversityItem["name"];
    obj.ipedsId = selectedUniversityItem["ipedsId"];
    if (
      ocrDataItem["detectedValues"].some((item) => item.mapWith === mapIdValue)
    ) {
      //let selectedUniversityItem = this.allUniversityList.find(item =>item.name==ocrDataItem.extraText);
      //let additionOfDetectedValues=0;
      for (const item of ocrDataItem["detectedValues"]) {
        if (item.mapWith === mapIdValue) {
          obj[item.fieldName] = item.value;
        }

        //additionOfDetectedValues+= +item.value;
      }
    }
    //obj.sumOfDetectedValues=additionOfDetectedValues;

    return obj;
  }

  hideSpinner() {
    return setTimeout(() => {
      return this.spinnerService.hide();
    }, 1000);
  }

  getUserName() {}

  getPath() {
    return this.apiService.getHost();
  }

  setDisable() {
    let disabled = true;
    if (
      this.fileUploadArray[this.index] != undefined &&
      this.fileUploadArray[this.index].fileIds.length > 0
    ) {
      disabled = false;
    }
    return disabled;
  }

  filterCollge(selectedClg: any) {
    this.filterCollegeItem = [];
    if (selectedClg?.selectedCollegeList.length > 0) {
      for (
        let index = 0;
        index < selectedClg?.selectedCollegeList?.length;
        index++
      ) {
        let element = selectedClg?.selectedCollegeList[index];
        let exitsIpeds = this.selectedUniversityList.some(
          (item) => item.ipedsId == element.ipedsId
        );
        if (exitsIpeds == false) {
          this.selectUniversity(
            "applyFilter",
            this.maxUniversityListArr.length,
            element
          );
        }
      }
    }
  }

  onChangeSearch(val: Searchconfig) {}

  numbersOnly(event: any) {
    let charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  // Ravi code
  // getAcceptanceRate(ipedsId: string, index: number) {
  //   let admissionsRate = 0;
  //   if (this.selectedUniversityList[index]) {
  //     if (
  //       //
  //       this.selectedUniversityList[index].ipedsId == ipedsId &&
  //       this.selectedUniversityList[index]?.CollegeWiseProgramList?.ipedsROIData
  //         ?.acceptanceRate
  //     ) {
  //       admissionsRate = Math.ceil(
  //         Number(
  //           this.selectedUniversityList[index]?.CollegeWiseProgramList
  //             ?.ipedsROIData?.acceptanceRate
  //         ) * 100
  //       );
  //     }
  //   }

  //   return admissionsRate;
  // }
  ispredicated: boolean = false;
  getAcceptanceRate(ipedsId: string, index: number) {
    let admissionsRate = 0;
    if (this.selectedUniversityList[index]) {
      if (
        //
        this.selectedUniversityList[index].ipedsId == ipedsId &&
        this.selectedUniversityList[index]?.CollegeWiseProgramList
          ?.virtueROIData
      ) {
        const virtueData =
          this.selectedUniversityList[index]?.CollegeWiseProgramList
            ?.virtueROIData;
        if (virtueData?.acceptanceRateInfo.type == "ACTUAL") {
          this.ispredicated = false;
          admissionsRate = Math.ceil(
            Number(virtueData.acceptanceRateInfo.value) * 100
          );
          return admissionsRate;
        } else {
          if (virtueData?.acceptanceRateInfo.type == "PREDICTED") {
            this.ispredicated = true;
            admissionsRate = Math.ceil(
              Number(virtueData.acceptanceRateInfo.value) * 100
            );
            return admissionsRate;
          }
        }
      }

      // return admissionsRate;
    }
  }

  getAcceptanceRatevirtue(
    ipedsId: string,
    index: number
  ): { value: number | null; type: string } {
    let admissionsRate: number | null = null;
    let type: string = "";

    if (this.selectedUniversityList[index]) {
      if (
        this.selectedUniversityList[index]?.ipedsId == ipedsId &&
        this.selectedUniversityList[index]?.CollegeWiseProgramList
          ?.virtueROIData
      ) {
        const virtueData =
          this.selectedUniversityList[index]?.CollegeWiseProgramList
            ?.virtueROIData;
        if (virtueData?.acceptanceRateInfo?.type == "ACTUAL") {
          this.ispredicated = false;
          admissionsRate = Math.ceil(
            Number(virtueData?.acceptanceRateInfo?.value) * 100
          );
          type = "ACTUAL";
        } else if (virtueData?.acceptanceRateInfo?.type == "PREDICTED") {
          this.ispredicated = true;
          admissionsRate = Math.ceil(
            Number(virtueData.acceptanceRateInfo?.value) * 100
          );
          type = "PREDICTED";
        }
      }
    }
    return { value: admissionsRate, type: type };
  }
  getGratuationRatevirtue(
    ipedsId: string,
    index: number
  ): { value: number | null; type: string } {
    let graduationRate: number | null = null;
    let type: string = "";

    if (this.selectedUniversityList[index]) {
      if (
        this.selectedUniversityList[index].ipedsId == ipedsId &&
        this.selectedUniversityList[index]?.CollegeWiseProgramList
          ?.virtueROIData
      ) {
        const virtueData =
          this.selectedUniversityList[index]?.CollegeWiseProgramList
            ?.virtueROIData;
        if (virtueData?.graduationRateinfo?.type == "ACTUAL") {
          this.ispredicated = false;
          graduationRate = Math.ceil(
            Number(virtueData.graduationRateinfo?.value) * 100
          );
          type = "ACTUAL";
        } else if (virtueData?.graduationRateinfo?.type == "PREDICTED") {
          this.ispredicated = true;
          graduationRate = Math.ceil(
            Number(virtueData.graduationRateinfo.value) * 100
          );
          type = "PREDICTED";
        }
      }
    }
    return { value: graduationRate, type: type };
  }

  getAcceptanceRateResult(ipedsId: string, index: number) {
    let admissionsRate = 0;
    if (this.selectedUniversityList[index]) {
      if (
        //
        this.selectedUniversityList[index].ipedsId == ipedsId &&
        this.selectedUniversityList[index]?.CollegeWiseProgramList?.ipedsROIData
          ?.acceptanceRate
      ) {
        admissionsRate =
          this.selectedUniversityList[index]?.CollegeWiseProgramList
            ?.ipedsROIData?.acceptanceRate;
      }
    }

    return admissionsRate;
  }

  setValueWithPercentage(val: number) {
    return Math.ceil(Number(val) * 100) + "%";
  }

  setAnswerMap() {
    this.setInterestPageAnswer(
      "ocrResponseListTotal",
      "",
      this.ocrResponseListTotal,
      ""
    );
    this.setInterestPageAnswer("domesileStatus", "", this.domesileStatus, "");
    this.setInterestPageAnswer("residencyStatus", "", this.residencyStatus, "");
    this.setArrayListInAnswerMap();
  }

  uncheckedCollege(clg: any, i: number) {
    if (clg?.selectedClg && clg?.selectedClg != undefined && i == 9999) {
      let data = this.maxUniversityListArr.find(
        (elm) => elm.ipedsId == clg?.selectedClg?.ipedsId
      );
      let index: number = this.maxUniversityListArr.indexOf(data);
      this.globalvar.deleteBy = "";
      this.deleteAnswerMapEvent(
        clg.selectedClg.stateCode,
        clg.selectedClg.ipedsId,
        index
      );
      this.deleteArrayListRows(index);
      this.deleteAnswerMapStateGrantList(
        clg.selectedClg.stateCode.toLowerCase(),
        clg.selectedClg.ipedsId,
        index
      );

      this.deleteAnswerMapStateList(
        clg.selectedClg.stateCode.toLowerCase(),
        clg.selectedClg.ipedsId,
        index
      );
      this.setAnswerMap();
    }
  }

  setDefaultSelectedColleges() {
    // let selectedStates = this.CollegeSelctionList.get("selectedStates");
    // if (selectedStates != undefined) {
    //   this.selectedStates = selectedStates.list;
    // }

    // let isSelectedUniversityItems = this.CollegeSelctionList.get(
    //   "isSelectedUniversityItems"
    // );
    // if (isSelectedUniversityItems != undefined) {
    //   this.isSelectedUniversityItems = isSelectedUniversityItems.list;
    // }

    let maxUniversityListArr = this.CollegeSelctionList.get(
      "maxUniversityListArr"
    );
    if (maxUniversityListArr != undefined) {
      this.maxUniversityListArr = maxUniversityListArr.list;
    }

    let selectedUniversityList = this.CollegeSelctionList.get(
      "selectedUniversityList"
    );
    if (selectedUniversityList != undefined) {
      if (selectedUniversityList.list.length > 0) {
        selectedUniversityList.list.forEach((el, index) => {
          // this.selectedUniversityList[index] = el;
          this.setCollegeProfileData(el, index, "", el);
          if (this.globalvar.saveChangedDeduct == true) {
            this.getDataCampuseAndToggleValue(index, el.ipedsId, "");
          }
        });
        this.setArrayListInAnswerMap();
      }
    }

    // let yearWiseAffinityQuestion = this.CollegeSelctionList.get(
    //   "yearWiseAffinityQuestion"
    // );
    // if (yearWiseAffinityQuestion != undefined) {
    //   this.yearWiseAffinityQuestion = yearWiseAffinityQuestion.list;
    // }

    // let selectedUniversityCSSProfile = this.CollegeSelctionList.get(
    //   "selectedUniversityCSSProfile"
    // );
    // if (selectedUniversityCSSProfile != undefined) {
    //   this.selectedUniversityCSSProfile = selectedUniversityCSSProfile.list;
    // }

    // let efcFieldValue = this.CollegeSelctionList.get("efcFieldValue");
    // if (efcFieldValue != undefined) {
    //   if (efcFieldValue.list.length > 0) {
    //     efcFieldValue.list.forEach((el, index) => {
    //       if (el) {
    //         this.efcFieldValue[index] = el;
    //       }
    //     });
    //   }
    // }
  }

  selectCollegeReciprocityStateWise(statCode: string) {
    let selectedUniversityList = this.CollegeSelctionList.get(
      "selectedUniversityList"
    );
    if (selectedUniversityList != undefined) {
      if (selectedUniversityList.list.length > 0) {
        selectedUniversityList.list.forEach((el, index) => {
          if (el.stateCode.toLowerCase() == statCode.toLowerCase()) {
            this.getDataCampuseAndToggleValue(
              index,
              el.ipedsId,
              "reciprocityState"
            );
            this.setArrayListInAnswerMap();
          }
        });
      }
    }
  }
  checkIsReciprocityState(statecode: string, index: number) {
    const checkRepocityState = this.globalvar.ReciprocitySelectedStateList.some(
      (selectedItem) => selectedItem === statecode.toLowerCase()
    );
    if (
      checkRepocityState == true &&
      this.domesileStatus[index] == "OUT_STATE"
    ) {
      return true;
    } else {
      return false;
    }
  }

  setArrayListInAnswerMap() {
    this.setInterestPageAnswer("selectedStates", "", this.selectedStates, "");
    this.setInterestPageAnswer(
      "selectedUniversityList",
      "",
      this.selectedUniversityList,
      ""
    );
    this.setInterestPageAnswer(
      "isSelectedUniversityItems",
      "",
      this.isSelectedUniversityItems,
      ""
    );
    this.setInterestPageAnswer(
      "maxUniversityListArr",
      "",
      this.maxUniversityListArr,
      ""
    );
    this.setInterestPageAnswer(
      "yearWiseAffinityQuestion",
      "",
      this.yearWiseAffinityQuestion,
      ""
    );
    this.setInterestPageAnswer(
      "selectedUniversityCSSProfile",
      "",
      this.selectedUniversityCSSProfile,
      ""
    );
    this.setInterestPageAnswer("efcFieldValue", "", this.efcFieldValue, "");
  }

  deleteRowEvent(clg: any, index: number) {
    if (clg && clg?.ipedsId) {
      this.globalvar.deleteBy = "deleteBtn";
      this.ipedsId = clg?.ipedsId;
      this.deleteBy = "deleteBtn";
      this.filterCollegeItem = [];
      this.deleteAnswerMapEvent(clg.stateCode, clg.ipedsId, index);
      this.deleteArrayListRows(index);
      this.deleteAnswerMapStateGrantList(
        clg.stateCode.toLowerCase(),
        clg.ipedsId,
        index
      );
      this.deleteAnswerMapStateList(
        clg.stateCode.toLowerCase(),
        clg.ipedsId,
        index
      );
      this.setAnswerMap();
    }
  }

  deleteAnswerMapStateGrantList(stateCode: string, ipeds: number, i: number) {
    let state = this.selectedUniversityList.filter(
      (ele) => ele.stateCode.toLowerCase() == stateCode
    );

    if (state.length == 0) {
      this.CollegeSelctionList.delete("stateGrant_" + stateCode.toLowerCase());
      this.globalvar.CollegeSelctionList.delete(
        "stateGrant_" + stateCode.toLowerCase()
      );
      // this.CollegeSelctionList.delete("stateGrant_"+ipeds +"_"+ stateCode.toLowerCase());
    }
  }

  deleteAnswerMapStateList(stateCode: string, ipeds: number, i: number) {
    let state = this.selectedUniversityList.filter(
      (ele) => ele.stateCode.toLowerCase() == stateCode
    );
    if (state.length == 0) {
      this.StateInOutMap.delete("state" + stateCode);
    }
  }

  deleteAnswerMapEvent(stateCode: string, ipeds: number, index: number) {
    // let ipeds = clg.ipedsId;
    this.CollegeSelctionList.delete("u" + ipeds);
    this.CollegeSelctionList.delete("r" + ipeds);
    this.CollegeSelctionList.delete("ul" + ipeds);
    if (this.yearWiseAffinityQuestion[index] != undefined) {
      let affiny = this.yearWiseAffinityQuestion[index];
      for (let i = 0; i < affiny.length; i++) {
        this.CollegeSelctionList.delete("aq" + ipeds + "-" + i);
        this.globalvar.CollegeSelctionList.delete("aq" + ipeds + "-" + i);
      }
    }
    if (this.selectedUniversityList[index]?.usingCSSProfile) {
      this.affinityQuestionAnswer.delete("aq" + ipeds + "-9999");
      this.globalvar.CollegeSelctionList.delete("aq" + ipeds + "-9999");
    }
  }

  removecss(index: number) {
    this.efcFieldValue[index] = [];
  }

  private openVfrUpload = this.dialogService.open<any>(
    new PolymorpheusComponent(VfrUploadComponent, this.injector),
    {
      data: "",
      dismissible: false,
      label: "ToolTip",
    }
  );

  openvfr(index: number, ipedsId: string, collegeName: string) {
    let data = {
      name: collegeName,
      ocrResponseListTotal: this.ocrResponseListTotal,
      index: index,
      ipedsId: ipedsId,
    };
    this.openVfrUpload = this.dialogService.open<any>(
      new PolymorpheusComponent(VfrUploadComponent, this.injector),
      {
        data: data,
        dismissible: false,
      }
    );
    this.openVfrUpload.subscribe({
      next: (data: any) => {
        if (data.isUploadedFile == true) {
          this.ocrResponseListTotal[data.index] = data.vfrFileUpdated[0];
          // this.ocrResponseListTotal[data.index]=data.ocrResponseList[data.index];

          this.setInterestPageAnswer(
            "ul" + data.ipedsId,
            data.ipedsId + "",
            data.vfrFileUpdated,
            "Uploaded"
          );

          this.setInterestPageAnswer(
            "ocrResponseListTotal",
            "",
            this.ocrResponseListTotal,
            ""
          );
        }
      },
      complete: () => {},
    });
  }

  setDefaultImage() {
    //  this.logoId = `https://cdn.virtueanalytics.com/college-logos/${ipedsId}.png`;
    const defaultImageUrl =
      "https://cdn.virtueanalytics.com/cache/college-icon-top5.png";
    const imageElement = event.target as HTMLImageElement;
    imageElement.src = defaultImageUrl;
    return defaultImageUrl;
  }

  logoId!: string;
  collegeLogoExists(ipedsId: string): boolean {
    // Check if the CDN image URL exists or not
    // You can implement your own logic here to determine if the image exists on the CDN
    // For simplicity, let's assume that if the ipedsId is a valid number, the image exists
    return !isNaN(Number(ipedsId));
  }
  AddHypen = false;
  getFirstAndLastWords(str) {
    let result = "";
    const words = str.split("-");
    if (words.length >= 2) {
      this.AddHypen = true;
      const zeroindexvalue = words[0];
      const space = zeroindexvalue.split(" ");
      let lastElement = space[space.length - 1];
      result = words[0].charAt(0) + lastElement.charAt(0);
      return result;
    } else {
      this.AddHypen = false;
      const firstLetters = str.split(" ");
      let lastElement = firstLetters[firstLetters.length - 1];
      result = words[0].charAt(0) + lastElement.charAt(0);
    }
    return result;
  }
  lastAssignedColorIndex: number = -1;

  AddRandomColor() {
    let color = "#";
    let randomColorIndex = this.lastAssignedColorIndex;
    while (randomColorIndex === this.lastAssignedColorIndex) {
      randomColorIndex = Math.floor(Math.random() * this.colors.length);
    }
    this.lastAssignedColorIndex = randomColorIndex;
    return color + this.colors[randomColorIndex];
  }
  getCssClass() {
    // Your condition to determine the class
    if (this.AddHypen == true) {
      return "addhypen";
    } else {
      return "notaddhypen";
    }
  }
  resetinputdata() {
    console.log(this.searchBoxvalue);
    this.searchBoxvalue = [];
  }
  @HostListener("document:click", ["$event"])
  DocumentClick(event: Event) {
    const helloElement = this.elem.nativeElement.querySelector(".hello");
    if (helloElement && helloElement.contains(event.target)) {
      this.showSuggestions = true;
      // this.clicked = "inside";
    } else {
      this.showSuggestions = false;

      // this.clicked = "outside";
    }
  }
}
